import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql'

import { UseMutationOptions, UseQueryOptions, useMutation, useQuery } from '@tanstack/react-query'

import { amplifyFetcher } from './fetcher'

export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  AWSDate: { input: string; output: string }
  AWSDateTime: { input: string; output: string }
  AWSEmail: { input: string; output: string }
  AWSIPAddress: { input: string; output: string }
  AWSJSON: { input: string; output: string }
  AWSPhone: { input: string; output: string }
  AWSTime: { input: string; output: string }
  AWSTimestamp: { input: number; output: number }
  AWSURL: { input: string; output: string }
}

export type ActivateInviteUserInput = {
  code: Scalars['String']['input']
}

export type ActivateInviteUserPayload = {
  __typename?: 'ActivateInviteUserPayload'
  clientMutationId: Scalars['String']['output']
  successful?: Maybe<Scalars['Boolean']['output']>
}

export type AiHeadlineArticleHeadline = {
  __typename?: 'AiHeadlineArticleHeadline'
  level: Scalars['Int']['output']
  text: Scalars['String']['output']
}

export type AiHeadlineArticleInfo = {
  __typename?: 'AiHeadlineArticleInfo'
  description: Scalars['String']['output']
  text: Scalars['String']['output']
}

export type AiHeadlineArticleStructureConnection = {
  __typename?: 'AiHeadlineArticleStructureConnection'
  headlines: Array<AiHeadlineArticleHeadline>
  info: Array<AiHeadlineArticleInfo>
  keyword: Scalars['String']['output']
  persona: Array<AiHeadlineArticleInfo>
  title: Scalars['String']['output']
}

export type AiHeadlineArticleStructureHistoriesInput = {
  type?: InputMaybe<Scalars['String']['input']>
}

export type AiHeadlineArticleStructureHistoriesResponse = {
  __typename?: 'AiHeadlineArticleStructureHistoriesResponse'
  histories: Array<AiHeadlineArticleStructureHistory>
}

export type AiHeadlineArticleStructureHistory = {
  __typename?: 'AiHeadlineArticleStructureHistory'
  createdAt: Scalars['String']['output']
  id: Scalars['String']['output']
  keyword: Scalars['String']['output']
  state: SuggestFetchState
}

export type AiHeadlineArticleStructureInput = {
  executeId: Scalars['String']['input']
}

export type BuildChataiRequestHeader = {
  __typename?: 'BuildChataiRequestHeader'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type BuildChataiRequestInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  message: Scalars['String']['input']
}

export enum BuildChataiRequestMethod {
  POST = 'POST',
}

export type BuildChataiRequestPayload = {
  __typename?: 'BuildChataiRequestPayload'
  body: Scalars['String']['output']
  headers: Array<BuildChataiRequestHeader>
  method: BuildChataiRequestMethod
  url: Scalars['AWSURL']['output']
}

export type ChataiConversation = Node & {
  __typename?: 'ChataiConversation'
  detail: Scalars['String']['output']
  id: Scalars['ID']['output']
  title?: Maybe<Scalars['String']['output']>
}

export type ChataiConversationPayload = {
  __typename?: 'ChataiConversationPayload'
  createdAt: Scalars['AWSDateTime']['output']
  current: Scalars['String']['output']
  messages: Array<ChataiMessage>
  title?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['AWSDateTime']['output']
}

export type ChataiConversationsConnection = {
  __typename?: 'ChataiConversationsConnection'
  items: Array<ChataiConversation>
  pagination: PaginationPayload
}

export type ChataiConversationsInput = {
  orderBy?: InputMaybe<ChataiConversationsOrder>
  pagination?: InputMaybe<PaginationInput>
}

export type ChataiConversationsOrder = {
  direction: OrderDirection
  field: ChataiConversationsOrderField
}

export enum ChataiConversationsOrderField {
  CREATED_AT = 'CREATED_AT',
  UPDATED_AT = 'UPDATED_AT',
}

export type ChataiLog = {
  __typename?: 'ChataiLog'
  createdAt: Scalars['AWSDateTime']['output']
  id: Scalars['ID']['output']
  messages: Scalars['String']['output']
  model: Scalars['String']['output']
  title?: Maybe<Scalars['String']['output']>
  tokens: Scalars['Int']['output']
  username: Scalars['String']['output']
}

export type ChataiLogsConnection = {
  __typename?: 'ChataiLogsConnection'
  items: Array<ChataiLog>
  pagination: PaginationPayload
}

export type ChataiLogsInput = {
  orderBy?: InputMaybe<ChataiLogsOrder>
  pagination?: InputMaybe<PaginationInput>
}

export type ChataiLogsOrder = {
  direction: OrderDirection
  field: ChataiLogsOrderField
}

export enum ChataiLogsOrderField {
  CREATED_AT = 'CREATED_AT',
  USER = 'USER',
}

export type ChataiMessage = {
  __typename?: 'ChataiMessage'
  children?: Maybe<Scalars['String']['output']>
  content: Scalars['String']['output']
  id: Scalars['ID']['output']
  parent: Scalars['String']['output']
  role: ChataiRole
}

export enum ChataiRole {
  ASSISTANT = 'ASSISTANT',
  SYSTEM = 'SYSTEM',
  USER = 'USER',
}

export type ChataiUsage = {
  __typename?: 'ChataiUsage'
  calls: Scalars['Int']['output']
  month: Scalars['String']['output']
  tokens: Scalars['Int']['output']
  users: Scalars['Int']['output']
}

export type Company = {
  __typename?: 'Company'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type CreateChataiConversationData = {
  __typename?: 'CreateChataiConversationData'
  id: Scalars['ID']['output']
  messages: Array<ChataiMessage>
}

export type CreateChataiConversationInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  message: Scalars['String']['input']
}

export type CreateChataiConversationPayload = {
  __typename?: 'CreateChataiConversationPayload'
  data?: Maybe<CreateChataiConversationData>
  error?: Maybe<Scalars['String']['output']>
  state: CreateChataiConversationState
}

export enum CreateChataiConversationState {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
}

export type CreateInviteUserInput = {
  domain: Scalars['String']['input']
  email: Scalars['AWSEmail']['input']
  name: Scalars['String']['input']
  projects?: InputMaybe<Array<Scalars['String']['input']>>
  role: CreateInviteUserRole
}

export type CreateInviteUserPayload = {
  __typename?: 'CreateInviteUserPayload'
  error?: Maybe<Scalars['String']['output']>
  successful?: Maybe<Scalars['Boolean']['output']>
}

export enum CreateInviteUserRole {
  ADMIN = 'ADMIN',
  RESTRICTED = 'RESTRICTED',
}

export type CreateUserInput = {
  email: Scalars['String']['input']
  name: Scalars['String']['input']
  password: Scalars['String']['input']
}

export type CreateUserPayload = {
  __typename?: 'CreateUserPayload'
  clientMutationId: Scalars['String']['output']
  successful?: Maybe<Scalars['Boolean']['output']>
}

export type DateRange = {
  end: Scalars['AWSDate']['input']
  start: Scalars['AWSDate']['input']
}

export type Deletable = {
  viewerCanDelete: Scalars['Boolean']['output']
}

export type DeleteChataiConversationPayload = {
  __typename?: 'DeleteChataiConversationPayload'
  clientMutationId: Scalars['String']['output']
}

export type DeleteChataiConversationsPayload = {
  __typename?: 'DeleteChataiConversationsPayload'
  successful?: Maybe<Scalars['Boolean']['output']>
}

export type DeleteUserInput = {
  id: Scalars['ID']['input']
}

export enum ExchangeRateBase {
  USD = 'USD',
}

export type ExchangeRateInput = {
  base: ExchangeRateBase
}

export type ExchangeRatePayload = {
  __typename?: 'ExchangeRatePayload'
  jpy: ExchangeRateSymbol
}

export type ExchangeRateSymbol = {
  __typename?: 'ExchangeRateSymbol'
  rate: Scalars['Float']['output']
  updatedAt: Scalars['AWSTimestamp']['output']
}

export type FetchAiHeadlineArticleStructureInput = {
  keyword: Scalars['String']['input']
}

export type FetchAiHeadlineArticleStructureResponse = {
  __typename?: 'FetchAiHeadlineArticleStructureResponse'
  executeId: Scalars['String']['output']
}

export type FetchHeadlineArticleStructureInput = {
  keyword: Scalars['String']['input']
}

export type FetchHeadlineArticleStructureResponse = {
  __typename?: 'FetchHeadlineArticleStructureResponse'
  executeId: Scalars['String']['output']
}

export type FetchRelatedKeywordsInput = {
  keyword: Scalars['String']['input']
}

export type FetchRelatedKeywordsResponse = {
  __typename?: 'FetchRelatedKeywordsResponse'
  executeId: Scalars['String']['output']
}

export type FetchSuggestsInput = {
  keyword: Scalars['String']['input']
}

export type FetchSuggestsResponse = {
  __typename?: 'FetchSuggestsResponse'
  executeId: Scalars['String']['output']
}

export type GenerateChataiTitlePayload = {
  __typename?: 'GenerateChataiTitlePayload'
  title: Scalars['String']['output']
}

export type HeadlineArticleHeadline = {
  __typename?: 'HeadlineArticleHeadline'
  level: Scalars['Int']['output']
  text: Scalars['String']['output']
}

export type HeadlineArticleStructureConnection = {
  __typename?: 'HeadlineArticleStructureConnection'
  items: Array<HeadlineArticleStructurePayload>
  keyword: Scalars['String']['output']
}

export type HeadlineArticleStructureHistoriesInput = {
  type?: InputMaybe<Scalars['String']['input']>
}

export type HeadlineArticleStructureHistoriesResponse = {
  __typename?: 'HeadlineArticleStructureHistoriesResponse'
  histories: Array<HeadlineArticleStructureHistory>
}

export type HeadlineArticleStructureHistory = {
  __typename?: 'HeadlineArticleStructureHistory'
  createdAt: Scalars['String']['output']
  id: Scalars['String']['output']
  keyword: Scalars['String']['output']
  state: SuggestFetchState
}

export type HeadlineArticleStructureInput = {
  executeId: Scalars['String']['input']
}

export type HeadlineArticleStructurePayload = {
  __typename?: 'HeadlineArticleStructurePayload'
  description: Scalars['String']['output']
  headlines: Array<HeadlineArticleHeadline>
  length: Scalars['Int']['output']
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type Mutation = {
  __typename?: 'Mutation'
  activateInviteUser: ActivateInviteUserPayload
  buildChataiRequest: BuildChataiRequestPayload
  createChataiConversation: CreateChataiConversationPayload
  createInviteUser: CreateInviteUserPayload
  createUser: CreateUserPayload
  deleteChataiConversation: DeleteChataiConversationPayload
  deleteChataiConversations: DeleteChataiConversationsPayload
  deleteUser: UpdateUserPayload
  fetchAiHeadlineArticleStructure: FetchAiHeadlineArticleStructureResponse
  fetchHeadlineArticleStructure: FetchAiHeadlineArticleStructureResponse
  fetchRelatedKeywords: FetchRelatedKeywordsResponse
  fetchSuggests: FetchSuggestsResponse
  generateChataiTitle?: Maybe<GenerateChataiTitlePayload>
  sendInviteUserEmail: SendInviteUserEmailPayload
  updateUser: UpdateUserPayload
  updateUserActive: UpdateUserActivePayload
  updateUserEmail: UpdateUserEmailPayload
  updateUserPermission: UpdateUserPermissionPayload
}

export type MutationActivateInviteUserArgs = {
  input: ActivateInviteUserInput
}

export type MutationBuildChataiRequestArgs = {
  input: BuildChataiRequestInput
}

export type MutationCreateChataiConversationArgs = {
  input: CreateChataiConversationInput
}

export type MutationCreateInviteUserArgs = {
  input: CreateInviteUserInput
}

export type MutationCreateUserArgs = {
  input: CreateUserInput
}

export type MutationDeleteChataiConversationArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteUserArgs = {
  input: DeleteUserInput
}

export type MutationFetchAiHeadlineArticleStructureArgs = {
  input: FetchAiHeadlineArticleStructureInput
}

export type MutationFetchHeadlineArticleStructureArgs = {
  input: FetchHeadlineArticleStructureInput
}

export type MutationFetchRelatedKeywordsArgs = {
  input: FetchRelatedKeywordsInput
}

export type MutationFetchSuggestsArgs = {
  input: FetchSuggestsInput
}

export type MutationGenerateChataiTitleArgs = {
  id: Scalars['ID']['input']
}

export type MutationSendInviteUserEmailArgs = {
  input: SendInviteUserEmailInput
}

export type MutationUpdateUserArgs = {
  input: UpdateUserInput
}

export type MutationUpdateUserActiveArgs = {
  input: UpdateUserActiveInput
}

export type MutationUpdateUserEmailArgs = {
  input: UpdateUserEmailInput
}

export type MutationUpdateUserPermissionArgs = {
  input: UpdateUserPermissionInput
}

export type Node = {
  id: Scalars['ID']['output']
}

export type NumberRange = {
  end?: InputMaybe<Scalars['Int']['input']>
  start?: InputMaybe<Scalars['Int']['input']>
}

export enum OrderDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type PageInfo = {
  __typename?: 'PageInfo'
  endCursor?: Maybe<Scalars['String']['output']>
  hasNextPage: Scalars['Boolean']['output']
  hasPreviousPage: Scalars['Boolean']['output']
  startCursor?: Maybe<Scalars['String']['output']>
}

export type PaginationInput = {
  page: Scalars['Int']['input']
  pageSize?: InputMaybe<Scalars['Int']['input']>
  size: Scalars['Int']['input']
}

export type PaginationPayload = {
  __typename?: 'PaginationPayload'
  page: Scalars['Int']['output']
  pageSize: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

export enum Permission {
  ACCOUNT_MANAGEMENT = 'ACCOUNT_MANAGEMENT',
  ACCOUNT_MANAGEMENT_GRANNET = 'ACCOUNT_MANAGEMENT_GRANNET',
  ACCOUNT_MANAGEMENT_INHOUSE = 'ACCOUNT_MANAGEMENT_INHOUSE',
  ACCOUNT_MANAGEMENT_SITE_ASSIGNMENT = 'ACCOUNT_MANAGEMENT_SITE_ASSIGNMENT',
  ADMIN_ACCOUNT = 'ADMIN_ACCOUNT',
  ADMIN_ADVERTISEMENT = 'ADMIN_ADVERTISEMENT',
  ADMIN_ANALYSIS_SITE_ANALYSIS = 'ADMIN_ANALYSIS_SITE_ANALYSIS',
  ADMIN_ANALYSIS_SITE_COMPETITIVE = 'ADMIN_ANALYSIS_SITE_COMPETITIVE',
  ADMIN_BUSINESS_CALENDAR = 'ADMIN_BUSINESS_CALENDAR',
  ADMIN_CHAT = 'ADMIN_CHAT',
  ADMIN_COMPANY = 'ADMIN_COMPANY',
  ADMIN_IMPROVEMENT = 'ADMIN_IMPROVEMENT',
  ADMIN_IMPROVEMENT_IMPORT = 'ADMIN_IMPROVEMENT_IMPORT',
  ADMIN_INVALID_PERMISSION = 'ADMIN_INVALID_PERMISSION',
  ADMIN_MAIL = 'ADMIN_MAIL',
  ADMIN_NEWS = 'ADMIN_NEWS',
  ADMIN_NOTIFICATION = 'ADMIN_NOTIFICATION',
  ADMIN_POSITION_TRACKING = 'ADMIN_POSITION_TRACKING',
  ADMIN_SEO_NEWS = 'ADMIN_SEO_NEWS',
  ADMIN_TASK = 'ADMIN_TASK',
  ADMIN_WEBMASTER = 'ADMIN_WEBMASTER',
  ADMIN_WEBMASTER_ASSIGNED = 'ADMIN_WEBMASTER_ASSIGNED',
  ADMIN_WEBMASTER_TASK = 'ADMIN_WEBMASTER_TASK',
  ADMIN_ZONE = 'ADMIN_ZONE',
  ADVERTISEMENT_REPORT = 'ADVERTISEMENT_REPORT',
  AGENCY = 'AGENCY',
  AGENCY_DISTRIBUTE = 'AGENCY_DISTRIBUTE',
  AGENCY_MAIL = 'AGENCY_MAIL',
  AGENCY_POSITION_TRACKING = 'AGENCY_POSITION_TRACKING',
  ANALYSIS_REPORT = 'ANALYSIS_REPORT',
  ANALYSIS_SITE_ANALYSIS = 'ANALYSIS_SITE_ANALYSIS',
  ANALYSIS_SITE_COMPETITIVE = 'ANALYSIS_SITE_COMPETITIVE',
  BULL = 'BULL',
  CHAT = 'CHAT',
  CLIENT_MEMBER = 'CLIENT_MEMBER',
  CLIENT_OWNER = 'CLIENT_OWNER',
  CONTACT = 'CONTACT',
  CUSTOMER_PRODUCTION = 'CUSTOMER_PRODUCTION',
  DASHBOARD = 'DASHBOARD',
  DEMO_ZONE = 'DEMO_ZONE',
  ENTRY_PLAN = 'ENTRY_PLAN',
  FINANCIAL_MANAGE = 'FINANCIAL_MANAGE',
  FREE_PLAN = 'FREE_PLAN',
  IMPROVEMENT = 'IMPROVEMENT',
  INHOUSE_ZONE = 'INHOUSE_ZONE',
  INVITE_LINK = 'INVITE_LINK',
  KPI = 'KPI',
  LIGHT_PLAN = 'LIGHT_PLAN',
  MAIL = 'MAIL',
  NEWS = 'NEWS',
  PAID = 'PAID',
  PAID_LEGULAR = 'PAID_LEGULAR',
  PAID_PREMIUM = 'PAID_PREMIUM',
  PAYMENT = 'PAYMENT',
  POSITION_TRACKING = 'POSITION_TRACKING',
  PUBLIC_ZONE = 'PUBLIC_ZONE',
  SITE_SETTING = 'SITE_SETTING',
  STANDARD_PLAN = 'STANDARD_PLAN',
  SUMMARY = 'SUMMARY',
  TASK = 'TASK',
  TREND_REPORT = 'TREND_REPORT',
  USER_MANAGEMENT = 'USER_MANAGEMENT',
  VERIFICATION = 'VERIFICATION',
  VERIFICATION_INHOUSE = 'VERIFICATION_INHOUSE',
  WEBMASTER_CONTACT = 'WEBMASTER_CONTACT',
  WORK = 'WORK',
}

export type ProjectUser = Node & {
  __typename?: 'ProjectUser'
  email: Scalars['AWSEmail']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  permissions?: Maybe<Array<Scalars['String']['output']>>
  role: ProjectUserRole
  self?: Maybe<Scalars['Boolean']['output']>
  state: ProjectUserState
}

export enum ProjectUserEditableRole {
  ADMIN = 'ADMIN',
  RESTRICTED = 'RESTRICTED',
}

export enum ProjectUserRole {
  ADMIN = 'ADMIN',
  OWNER = 'OWNER',
  RESTRICTED = 'RESTRICTED',
}

export enum ProjectUserState {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  INVITATION = 'INVITATION',
}

export type Query = {
  __typename?: 'Query'
  aiHeadlineArticleStructure: AiHeadlineArticleStructureConnection
  aiHeadlineArticleStructureHistories: AiHeadlineArticleStructureHistoriesResponse
  chataiConversation?: Maybe<ChataiConversationPayload>
  chataiConversations?: Maybe<ChataiConversationsConnection>
  chataiLogs?: Maybe<ChataiLogsConnection>
  chataiUsage?: Maybe<Array<ChataiUsage>>
  exchangeRate?: Maybe<ExchangeRatePayload>
  headlineArticleStructure: HeadlineArticleStructureConnection
  headlineArticleStructureHistories: HeadlineArticleStructureHistoriesResponse
  relatedKeywordHistories: RelatedKeywordHistoriesResponse
  relatedKeywords: RelatedKeywordsResponse
  suggestHistories: SuggestsHistoryResponse
  suggests: SuggestsResponse
  user?: Maybe<User>
  users?: Maybe<UsersConnection>
  viewer: Viewer
}

export type QueryAiHeadlineArticleStructureArgs = {
  input: AiHeadlineArticleStructureInput
}

export type QueryAiHeadlineArticleStructureHistoriesArgs = {
  input?: InputMaybe<AiHeadlineArticleStructureHistoriesInput>
}

export type QueryChataiConversationArgs = {
  id: Scalars['ID']['input']
}

export type QueryChataiConversationsArgs = {
  input: ChataiConversationsInput
}

export type QueryChataiLogsArgs = {
  input: ChataiLogsInput
}

export type QueryExchangeRateArgs = {
  input: ExchangeRateInput
}

export type QueryHeadlineArticleStructureArgs = {
  input: HeadlineArticleStructureInput
}

export type QueryHeadlineArticleStructureHistoriesArgs = {
  input?: InputMaybe<HeadlineArticleStructureHistoriesInput>
}

export type QueryRelatedKeywordHistoriesArgs = {
  input?: InputMaybe<RelatedKeywordHistoriesInput>
}

export type QueryRelatedKeywordsArgs = {
  input: RelatedKeywordsInput
}

export type QuerySuggestHistoriesArgs = {
  input?: InputMaybe<SuggestHistoriesInput>
}

export type QuerySuggestsArgs = {
  input: SuggestsInput
}

export type QueryUserArgs = {
  id: Scalars['ID']['input']
}

export type QueryUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryViewerArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export enum QueryType {
  BUY = 'BUY',
  DO = 'DO',
  GO = 'GO',
  KNOW = 'KNOW',
}

export type RelatedKeywordHistoriesInput = {
  type?: InputMaybe<Scalars['String']['input']>
}

export type RelatedKeywordHistoriesResponse = {
  __typename?: 'RelatedKeywordHistoriesResponse'
  histories: Array<RelatedKeywordHistory>
}

export type RelatedKeywordHistory = {
  __typename?: 'RelatedKeywordHistory'
  createdAt: Scalars['String']['output']
  id: Scalars['String']['output']
  keyword: Scalars['String']['output']
  state: SuggestFetchState
}

export type RelatedKeywordsInput = {
  executeId: Scalars['String']['input']
}

export type RelatedKeywordsResponse = {
  __typename?: 'RelatedKeywordsResponse'
  ideas: Array<SuggestIdeas>
}

export type SendInviteUserEmailInput = {
  domain: Scalars['String']['input']
  id: Scalars['String']['input']
}

export type SendInviteUserEmailPayload = {
  __typename?: 'SendInviteUserEmailPayload'
  clientMutationId: Scalars['String']['output']
}

export enum SuggestFetchState {
  COMPLETED = 'COMPLETED',
  FAILD = 'FAILD',
  IN_PROGRESS = 'IN_PROGRESS',
}

export type SuggestHistoriesInput = {
  type?: InputMaybe<Scalars['String']['input']>
}

export type SuggestHistory = {
  __typename?: 'SuggestHistory'
  createdAt: Scalars['String']['output']
  id: Scalars['String']['output']
  keyword: Scalars['String']['output']
  state: SuggestFetchState
}

export type SuggestIdeas = {
  __typename?: 'SuggestIdeas'
  avgMonthlySearches?: Maybe<Scalars['Int']['output']>
  competition?: Maybe<Scalars['String']['output']>
  competitionIndex?: Maybe<Scalars['Int']['output']>
  highTopOfPageBid?: Maybe<Scalars['Float']['output']>
  keyword?: Maybe<Scalars['String']['output']>
  lowTopOfPageBid?: Maybe<Scalars['Float']['output']>
  query?: Maybe<Scalars['String']['output']>
  searchVolumes?: Maybe<Array<Maybe<SuggestIdeasSearchVolumes>>>
}

export type SuggestIdeasSearchVolumes = {
  __typename?: 'SuggestIdeasSearchVolumes'
  month?: Maybe<Scalars['Int']['output']>
  searches?: Maybe<Scalars['Int']['output']>
  year?: Maybe<Scalars['Int']['output']>
}

export type SuggestsHistoryResponse = {
  __typename?: 'SuggestsHistoryResponse'
  histories: Array<SuggestHistory>
}

export type SuggestsInput = {
  executeId: Scalars['String']['input']
}

export type SuggestsResponse = {
  __typename?: 'SuggestsResponse'
  additionalSuggests: Array<Maybe<Array<Scalars['String']['output']>>>
  alphabetPlusSuggests: Array<Maybe<Array<Scalars['String']['output']>>>
  keyword: Scalars['String']['output']
  plusSuggests: Array<Maybe<Array<Scalars['String']['output']>>>
  suggests: Array<Scalars['String']['output']>
}

export type UpdateUserActiveControl = {
  active: Scalars['Boolean']['input']
  userId: Scalars['String']['input']
}

export type UpdateUserActiveInput = {
  controls: Array<UpdateUserActiveControl>
}

export type UpdateUserActivePayload = {
  __typename?: 'UpdateUserActivePayload'
  successful?: Maybe<Scalars['Boolean']['output']>
}

export type UpdateUserEmailInput = {
  code: Scalars['String']['input']
}

export type UpdateUserEmailPayload = {
  __typename?: 'UpdateUserEmailPayload'
  clientMutationId: Scalars['String']['output']
  successful?: Maybe<Scalars['Boolean']['output']>
}

export type UpdateUserInput = {
  domain: Scalars['String']['input']
  email?: InputMaybe<Scalars['AWSEmail']['input']>
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  password?: InputMaybe<Scalars['String']['input']>
  projects?: InputMaybe<Array<Scalars['String']['input']>>
  role: ProjectUserEditableRole
}

export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload'
  clientMutationId: Scalars['String']['output']
  error?: Maybe<Scalars['String']['output']>
  isEmailChange?: Maybe<Scalars['Boolean']['output']>
}

export type UpdateUserPermissionInput = {
  allow: Scalars['Boolean']['input']
  projectId: Scalars['String']['input']
  userId: Scalars['String']['input']
}

export type UpdateUserPermissionPayload = {
  __typename?: 'UpdateUserPermissionPayload'
  clientMutationId: Scalars['String']['output']
}

export type User = Node & {
  __typename?: 'User'
  avatarUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  login: Scalars['String']['output']
}

export type UsersConnection = {
  __typename?: 'UsersConnection'
  hasNextPage: Scalars['Boolean']['output']
  hasPreviousPage: Scalars['Boolean']['output']
  items?: Maybe<Array<ProjectUser>>
  total?: Maybe<Scalars['Int']['output']>
}

export type Viewer = {
  __typename?: 'Viewer'
  permissions: Array<Permission>
  user: User
}

export type AiHeadlineArticleStructureQueryVariables = Exact<{
  input: AiHeadlineArticleStructureInput
}>

export type AiHeadlineArticleStructureQuery = {
  __typename?: 'Query'
  aiHeadlineArticleStructure: {
    __typename?: 'AiHeadlineArticleStructureConnection'
    title: string
    keyword: string
    headlines: Array<{ __typename?: 'AiHeadlineArticleHeadline'; level: number; text: string }>
    info: Array<{ __typename?: 'AiHeadlineArticleInfo'; text: string; description: string }>
    persona: Array<{ __typename?: 'AiHeadlineArticleInfo'; text: string; description: string }>
  }
}

export type AiHeadlineArticleStructureHistoriesQueryVariables = Exact<{
  input?: InputMaybe<AiHeadlineArticleStructureHistoriesInput>
}>

export type AiHeadlineArticleStructureHistoriesQuery = {
  __typename?: 'Query'
  aiHeadlineArticleStructureHistories: {
    __typename?: 'AiHeadlineArticleStructureHistoriesResponse'
    histories: Array<{
      __typename?: 'AiHeadlineArticleStructureHistory'
      id: string
      keyword: string
      state: SuggestFetchState
      createdAt: string
    }>
  }
}

export type FetchAiHeadlineArticleStructureMutationVariables = Exact<{
  input: FetchAiHeadlineArticleStructureInput
}>

export type FetchAiHeadlineArticleStructureMutation = {
  __typename?: 'Mutation'
  fetchAiHeadlineArticleStructure: { __typename?: 'FetchAiHeadlineArticleStructureResponse'; executeId: string }
}

export type ViewerPermissionQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>
}>

export type ViewerPermissionQuery = {
  __typename?: 'Query'
  viewer: {
    __typename?: 'Viewer'
    permissions: Array<Permission>
    user: { __typename?: 'User'; id: string; login: string; avatarUrl?: string | null }
  }
}

export type UserFragment = { __typename?: 'User'; id: string; login: string; avatarUrl?: string | null }

export type ChataiConversationQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ChataiConversationQuery = {
  __typename?: 'Query'
  chataiConversation?: {
    __typename?: 'ChataiConversationPayload'
    title?: string | null
    createdAt: string
    updatedAt: string
    current: string
    messages: Array<{
      __typename?: 'ChataiMessage'
      id: string
      parent: string
      children?: string | null
      role: ChataiRole
      content: string
    }>
  } | null
}

export type ChataiConversationsQueryVariables = Exact<{
  input: ChataiConversationsInput
}>

export type ChataiConversationsQuery = {
  __typename?: 'Query'
  chataiConversations?: {
    __typename?: 'ChataiConversationsConnection'
    items: Array<{ __typename?: 'ChataiConversation'; id: string; title?: string | null; detail: string }>
    pagination: { __typename?: 'PaginationPayload'; page: number; pageSize: number; total: number }
  } | null
}

export type CreateChataiConversationMutationVariables = Exact<{
  input: CreateChataiConversationInput
}>

export type CreateChataiConversationMutation = {
  __typename?: 'Mutation'
  createChataiConversation: {
    __typename?: 'CreateChataiConversationPayload'
    state: CreateChataiConversationState
    error?: string | null
    data?: {
      __typename?: 'CreateChataiConversationData'
      id: string
      messages: Array<{
        __typename?: 'ChataiMessage'
        id: string
        parent: string
        children?: string | null
        role: ChataiRole
        content: string
      }>
    } | null
  }
}

export type BuildChataiRequestMutationVariables = Exact<{
  input: BuildChataiRequestInput
}>

export type BuildChataiRequestMutation = {
  __typename?: 'Mutation'
  buildChataiRequest: {
    __typename?: 'BuildChataiRequestPayload'
    url: string
    method: BuildChataiRequestMethod
    body: string
    headers: Array<{ __typename?: 'BuildChataiRequestHeader'; key: string; value: string }>
  }
}

export type DeleteChataiConversationMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteChataiConversationMutation = {
  __typename?: 'Mutation'
  deleteChataiConversation: { __typename?: 'DeleteChataiConversationPayload'; clientMutationId: string }
}

export type DeleteChataiConversationsMutationVariables = Exact<{ [key: string]: never }>

export type DeleteChataiConversationsMutation = {
  __typename?: 'Mutation'
  deleteChataiConversations: { __typename?: 'DeleteChataiConversationsPayload'; successful?: boolean | null }
}

export type GenerateChataiTitleMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GenerateChataiTitleMutation = {
  __typename?: 'Mutation'
  generateChataiTitle?: { __typename?: 'GenerateChataiTitlePayload'; title: string } | null
}

export type ChataiMessageFragment = {
  __typename?: 'ChataiMessage'
  id: string
  parent: string
  children?: string | null
  role: ChataiRole
  content: string
}

export type ChataiUsageQueryVariables = Exact<{
  input: ExchangeRateInput
}>

export type ChataiUsageQuery = {
  __typename?: 'Query'
  chataiUsage?: Array<{
    __typename?: 'ChataiUsage'
    month: string
    tokens: number
    calls: number
    users: number
  }> | null
  exchangeRate?: {
    __typename?: 'ExchangeRatePayload'
    jpy: { __typename?: 'ExchangeRateSymbol'; rate: number; updatedAt: number }
  } | null
}

export type ChataiLogsQueryVariables = Exact<{
  input: ChataiLogsInput
}>

export type ChataiLogsQuery = {
  __typename?: 'Query'
  chataiLogs?: {
    __typename?: 'ChataiLogsConnection'
    items: Array<{
      __typename?: 'ChataiLog'
      id: string
      username: string
      model: string
      tokens: number
      title?: string | null
      messages: string
      createdAt: string
    }>
    pagination: { __typename?: 'PaginationPayload'; page: number; pageSize: number; total: number }
  } | null
}

export type ExchangeRateQueryVariables = Exact<{
  input: ExchangeRateInput
}>

export type ExchangeRateQuery = {
  __typename?: 'Query'
  exchangeRate?: {
    __typename?: 'ExchangeRatePayload'
    jpy: { __typename?: 'ExchangeRateSymbol'; rate: number; updatedAt: number }
  } | null
}

export type HeadlineArticleStructureQueryVariables = Exact<{
  input: HeadlineArticleStructureInput
}>

export type HeadlineArticleStructureQuery = {
  __typename?: 'Query'
  headlineArticleStructure: {
    __typename?: 'HeadlineArticleStructureConnection'
    keyword: string
    items: Array<{
      __typename?: 'HeadlineArticleStructurePayload'
      title: string
      description: string
      length: number
      url: string
      headlines: Array<{ __typename?: 'HeadlineArticleHeadline'; level: number; text: string }>
    }>
  }
}

export type HeadlineArticleStructureHistoriesQueryVariables = Exact<{
  input?: InputMaybe<HeadlineArticleStructureHistoriesInput>
}>

export type HeadlineArticleStructureHistoriesQuery = {
  __typename?: 'Query'
  headlineArticleStructureHistories: {
    __typename?: 'HeadlineArticleStructureHistoriesResponse'
    histories: Array<{
      __typename?: 'HeadlineArticleStructureHistory'
      id: string
      keyword: string
      state: SuggestFetchState
      createdAt: string
    }>
  }
}

export type FetchHeadlineArticleStructureMutationVariables = Exact<{
  input: FetchHeadlineArticleStructureInput
}>

export type FetchHeadlineArticleStructureMutation = {
  __typename?: 'Mutation'
  fetchHeadlineArticleStructure: { __typename?: 'FetchAiHeadlineArticleStructureResponse'; executeId: string }
}

export type RelatedKeywordsQueryVariables = Exact<{
  input: RelatedKeywordsInput
}>

export type RelatedKeywordsQuery = {
  __typename?: 'Query'
  relatedKeywords: {
    __typename?: 'RelatedKeywordsResponse'
    ideas: Array<{
      __typename?: 'SuggestIdeas'
      keyword?: string | null
      query?: string | null
      avgMonthlySearches?: number | null
      competition?: string | null
      competitionIndex?: number | null
      lowTopOfPageBid?: number | null
      highTopOfPageBid?: number | null
      searchVolumes?: Array<{
        __typename?: 'SuggestIdeasSearchVolumes'
        year?: number | null
        month?: number | null
        searches?: number | null
      } | null> | null
    }>
  }
}

export type RelatedKeywordHistoriesQueryVariables = Exact<{
  input?: InputMaybe<RelatedKeywordHistoriesInput>
}>

export type RelatedKeywordHistoriesQuery = {
  __typename?: 'Query'
  relatedKeywordHistories: {
    __typename?: 'RelatedKeywordHistoriesResponse'
    histories: Array<{
      __typename?: 'RelatedKeywordHistory'
      id: string
      keyword: string
      state: SuggestFetchState
      createdAt: string
    }>
  }
}

export type FetchRelatedKeywordsMutationVariables = Exact<{
  input: FetchRelatedKeywordsInput
}>

export type FetchRelatedKeywordsMutation = {
  __typename?: 'Mutation'
  fetchRelatedKeywords: { __typename?: 'FetchRelatedKeywordsResponse'; executeId: string }
}

export type SuggestsQueryVariables = Exact<{
  input: SuggestsInput
}>

export type SuggestsQuery = {
  __typename?: 'Query'
  suggests: {
    __typename?: 'SuggestsResponse'
    keyword: string
    suggests: Array<string>
    additionalSuggests: Array<Array<string> | null>
    plusSuggests: Array<Array<string> | null>
    alphabetPlusSuggests: Array<Array<string> | null>
  }
}

export type SuggestHistoriesQueryVariables = Exact<{
  input?: InputMaybe<SuggestHistoriesInput>
}>

export type SuggestHistoriesQuery = {
  __typename?: 'Query'
  suggestHistories: {
    __typename?: 'SuggestsHistoryResponse'
    histories: Array<{
      __typename?: 'SuggestHistory'
      id: string
      keyword: string
      state: SuggestFetchState
      createdAt: string
    }>
  }
}

export type FetchSuggestsMutationVariables = Exact<{
  input: FetchSuggestsInput
}>

export type FetchSuggestsMutation = {
  __typename?: 'Mutation'
  fetchSuggests: { __typename?: 'FetchSuggestsResponse'; executeId: string }
}

export type UsersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type UsersQuery = {
  __typename?: 'Query'
  users?: {
    __typename?: 'UsersConnection'
    total?: number | null
    hasNextPage: boolean
    hasPreviousPage: boolean
    items?: Array<{
      __typename?: 'ProjectUser'
      id: string
      name: string
      email: string
      role: ProjectUserRole
      state: ProjectUserState
      self?: boolean | null
      permissions?: Array<string> | null
    }> | null
  } | null
}

export type ActivateInviteUserMutationVariables = Exact<{
  input: ActivateInviteUserInput
}>

export type ActivateInviteUserMutation = {
  __typename?: 'Mutation'
  activateInviteUser: {
    __typename?: 'ActivateInviteUserPayload'
    clientMutationId: string
    successful?: boolean | null
  }
}

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput
}>

export type CreateUserMutation = {
  __typename?: 'Mutation'
  createUser: { __typename?: 'CreateUserPayload'; clientMutationId: string; successful?: boolean | null }
}

export type CreateInviteUserMutationVariables = Exact<{
  input: CreateInviteUserInput
}>

export type CreateInviteUserMutation = {
  __typename?: 'Mutation'
  createInviteUser: { __typename?: 'CreateInviteUserPayload'; successful?: boolean | null; error?: string | null }
}

export type DeleteUserMutationVariables = Exact<{
  input: DeleteUserInput
}>

export type DeleteUserMutation = {
  __typename?: 'Mutation'
  deleteUser: { __typename?: 'UpdateUserPayload'; clientMutationId: string }
}

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput
}>

export type UpdateUserMutation = {
  __typename?: 'Mutation'
  updateUser: {
    __typename?: 'UpdateUserPayload'
    clientMutationId: string
    error?: string | null
    isEmailChange?: boolean | null
  }
}

export type UpdateUserPermissionMutationVariables = Exact<{
  input: UpdateUserPermissionInput
}>

export type UpdateUserPermissionMutation = {
  __typename?: 'Mutation'
  updateUserPermission: { __typename?: 'UpdateUserPermissionPayload'; clientMutationId: string }
}

export type UpdateUserActiveMutationVariables = Exact<{
  input: UpdateUserActiveInput
}>

export type UpdateUserActiveMutation = {
  __typename?: 'Mutation'
  updateUserActive: { __typename?: 'UpdateUserActivePayload'; successful?: boolean | null }
}

export type UpdateUserEmailMutationVariables = Exact<{
  input: UpdateUserEmailInput
}>

export type UpdateUserEmailMutation = {
  __typename?: 'Mutation'
  updateUserEmail: { __typename?: 'UpdateUserEmailPayload'; clientMutationId: string; successful?: boolean | null }
}

export type SendInviteUserEmailMutationVariables = Exact<{
  input: SendInviteUserEmailInput
}>

export type SendInviteUserEmailMutation = {
  __typename?: 'Mutation'
  sendInviteUserEmail: { __typename?: 'SendInviteUserEmailPayload'; clientMutationId: string }
}

export const UserFragmentDoc = `
    fragment user on User {
  id
  login
  avatarUrl
}
    `
export const ChataiMessageFragmentDoc = `
    fragment chataiMessage on ChataiMessage {
  id
  parent
  children
  role
  content
}
    `
export const AiHeadlineArticleStructureDocument = `
    query aiHeadlineArticleStructure($input: AiHeadlineArticleStructureInput!) {
  aiHeadlineArticleStructure(input: $input) {
    title
    keyword
    headlines {
      level
      text
    }
    info {
      text
      description
    }
    persona {
      text
      description
    }
  }
}
    `
export const useAiHeadlineArticleStructureQuery = <TData = AiHeadlineArticleStructureQuery, TError = unknown>(
  variables: AiHeadlineArticleStructureQueryVariables,
  options?: UseQueryOptions<AiHeadlineArticleStructureQuery, TError, TData>
) =>
  useQuery<AiHeadlineArticleStructureQuery, TError, TData>(
    ['aiHeadlineArticleStructure', variables],
    amplifyFetcher<AiHeadlineArticleStructureQuery, AiHeadlineArticleStructureQueryVariables>(
      AiHeadlineArticleStructureDocument,
      variables
    ),
    options
  )
export const AiHeadlineArticleStructureHistoriesDocument = `
    query aiHeadlineArticleStructureHistories($input: AiHeadlineArticleStructureHistoriesInput) {
  aiHeadlineArticleStructureHistories(input: $input) {
    histories {
      id
      keyword
      state
      createdAt
    }
  }
}
    `
export const useAiHeadlineArticleStructureHistoriesQuery = <
  TData = AiHeadlineArticleStructureHistoriesQuery,
  TError = unknown,
>(
  variables?: AiHeadlineArticleStructureHistoriesQueryVariables,
  options?: UseQueryOptions<AiHeadlineArticleStructureHistoriesQuery, TError, TData>
) =>
  useQuery<AiHeadlineArticleStructureHistoriesQuery, TError, TData>(
    variables === undefined
      ? ['aiHeadlineArticleStructureHistories']
      : ['aiHeadlineArticleStructureHistories', variables],
    amplifyFetcher<AiHeadlineArticleStructureHistoriesQuery, AiHeadlineArticleStructureHistoriesQueryVariables>(
      AiHeadlineArticleStructureHistoriesDocument,
      variables
    ),
    options
  )
export const FetchAiHeadlineArticleStructureDocument = `
    mutation fetchAiHeadlineArticleStructure($input: FetchAiHeadlineArticleStructureInput!) {
  fetchAiHeadlineArticleStructure(input: $input) {
    executeId
  }
}
    `
export const useFetchAiHeadlineArticleStructureMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    FetchAiHeadlineArticleStructureMutation,
    TError,
    FetchAiHeadlineArticleStructureMutationVariables,
    TContext
  >
) =>
  useMutation<
    FetchAiHeadlineArticleStructureMutation,
    TError,
    FetchAiHeadlineArticleStructureMutationVariables,
    TContext
  >(
    ['fetchAiHeadlineArticleStructure'],
    (variables?: FetchAiHeadlineArticleStructureMutationVariables) =>
      amplifyFetcher<FetchAiHeadlineArticleStructureMutation, FetchAiHeadlineArticleStructureMutationVariables>(
        FetchAiHeadlineArticleStructureDocument,
        variables
      )(),
    options
  )
export const ViewerPermissionDocument = `
    query viewerPermission($id: ID) {
  viewer(id: $id) {
    user {
      ...user
    }
    permissions
  }
}
    ${UserFragmentDoc}`
export const useViewerPermissionQuery = <TData = ViewerPermissionQuery, TError = unknown>(
  variables?: ViewerPermissionQueryVariables,
  options?: UseQueryOptions<ViewerPermissionQuery, TError, TData>
) =>
  useQuery<ViewerPermissionQuery, TError, TData>(
    variables === undefined ? ['viewerPermission'] : ['viewerPermission', variables],
    amplifyFetcher<ViewerPermissionQuery, ViewerPermissionQueryVariables>(ViewerPermissionDocument, variables),
    options
  )
export const ChataiConversationDocument = `
    query chataiConversation($id: ID!) {
  chataiConversation(id: $id) {
    title
    createdAt
    updatedAt
    messages {
      ...chataiMessage
    }
    current
  }
}
    ${ChataiMessageFragmentDoc}`
export const useChataiConversationQuery = <TData = ChataiConversationQuery, TError = unknown>(
  variables: ChataiConversationQueryVariables,
  options?: UseQueryOptions<ChataiConversationQuery, TError, TData>
) =>
  useQuery<ChataiConversationQuery, TError, TData>(
    ['chataiConversation', variables],
    amplifyFetcher<ChataiConversationQuery, ChataiConversationQueryVariables>(ChataiConversationDocument, variables),
    options
  )
export const ChataiConversationsDocument = `
    query chataiConversations($input: ChataiConversationsInput!) {
  chataiConversations(input: $input) {
    items {
      id
      title
      detail
    }
    pagination {
      page
      pageSize
      total
    }
  }
}
    `
export const useChataiConversationsQuery = <TData = ChataiConversationsQuery, TError = unknown>(
  variables: ChataiConversationsQueryVariables,
  options?: UseQueryOptions<ChataiConversationsQuery, TError, TData>
) =>
  useQuery<ChataiConversationsQuery, TError, TData>(
    ['chataiConversations', variables],
    amplifyFetcher<ChataiConversationsQuery, ChataiConversationsQueryVariables>(ChataiConversationsDocument, variables),
    options
  )
export const CreateChataiConversationDocument = `
    mutation createChataiConversation($input: CreateChataiConversationInput!) {
  createChataiConversation(input: $input) {
    state
    data {
      id
      messages {
        ...chataiMessage
      }
    }
    error
  }
}
    ${ChataiMessageFragmentDoc}`
export const useCreateChataiConversationMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateChataiConversationMutation,
    TError,
    CreateChataiConversationMutationVariables,
    TContext
  >
) =>
  useMutation<CreateChataiConversationMutation, TError, CreateChataiConversationMutationVariables, TContext>(
    ['createChataiConversation'],
    (variables?: CreateChataiConversationMutationVariables) =>
      amplifyFetcher<CreateChataiConversationMutation, CreateChataiConversationMutationVariables>(
        CreateChataiConversationDocument,
        variables
      )(),
    options
  )
export const BuildChataiRequestDocument = `
    mutation buildChataiRequest($input: BuildChataiRequestInput!) {
  buildChataiRequest(input: $input) {
    url
    method
    body
    headers {
      key
      value
    }
  }
}
    `
export const useBuildChataiRequestMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<BuildChataiRequestMutation, TError, BuildChataiRequestMutationVariables, TContext>
) =>
  useMutation<BuildChataiRequestMutation, TError, BuildChataiRequestMutationVariables, TContext>(
    ['buildChataiRequest'],
    (variables?: BuildChataiRequestMutationVariables) =>
      amplifyFetcher<BuildChataiRequestMutation, BuildChataiRequestMutationVariables>(
        BuildChataiRequestDocument,
        variables
      )(),
    options
  )
export const DeleteChataiConversationDocument = `
    mutation deleteChataiConversation($id: ID!) {
  deleteChataiConversation(id: $id) {
    clientMutationId
  }
}
    `
export const useDeleteChataiConversationMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteChataiConversationMutation,
    TError,
    DeleteChataiConversationMutationVariables,
    TContext
  >
) =>
  useMutation<DeleteChataiConversationMutation, TError, DeleteChataiConversationMutationVariables, TContext>(
    ['deleteChataiConversation'],
    (variables?: DeleteChataiConversationMutationVariables) =>
      amplifyFetcher<DeleteChataiConversationMutation, DeleteChataiConversationMutationVariables>(
        DeleteChataiConversationDocument,
        variables
      )(),
    options
  )
export const DeleteChataiConversationsDocument = `
    mutation deleteChataiConversations {
  deleteChataiConversations {
    successful
  }
}
    `
export const useDeleteChataiConversationsMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteChataiConversationsMutation,
    TError,
    DeleteChataiConversationsMutationVariables,
    TContext
  >
) =>
  useMutation<DeleteChataiConversationsMutation, TError, DeleteChataiConversationsMutationVariables, TContext>(
    ['deleteChataiConversations'],
    (variables?: DeleteChataiConversationsMutationVariables) =>
      amplifyFetcher<DeleteChataiConversationsMutation, DeleteChataiConversationsMutationVariables>(
        DeleteChataiConversationsDocument,
        variables
      )(),
    options
  )
export const GenerateChataiTitleDocument = `
    mutation generateChataiTitle($id: ID!) {
  generateChataiTitle(id: $id) {
    title
  }
}
    `
export const useGenerateChataiTitleMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<GenerateChataiTitleMutation, TError, GenerateChataiTitleMutationVariables, TContext>
) =>
  useMutation<GenerateChataiTitleMutation, TError, GenerateChataiTitleMutationVariables, TContext>(
    ['generateChataiTitle'],
    (variables?: GenerateChataiTitleMutationVariables) =>
      amplifyFetcher<GenerateChataiTitleMutation, GenerateChataiTitleMutationVariables>(
        GenerateChataiTitleDocument,
        variables
      )(),
    options
  )
export const ChataiUsageDocument = `
    query chataiUsage($input: ExchangeRateInput!) {
  chataiUsage {
    month
    tokens
    calls
    users
  }
  exchangeRate(input: $input) {
    jpy {
      rate
      updatedAt
    }
  }
}
    `
export const useChataiUsageQuery = <TData = ChataiUsageQuery, TError = unknown>(
  variables: ChataiUsageQueryVariables,
  options?: UseQueryOptions<ChataiUsageQuery, TError, TData>
) =>
  useQuery<ChataiUsageQuery, TError, TData>(
    ['chataiUsage', variables],
    amplifyFetcher<ChataiUsageQuery, ChataiUsageQueryVariables>(ChataiUsageDocument, variables),
    options
  )
export const ChataiLogsDocument = `
    query chataiLogs($input: ChataiLogsInput!) {
  chataiLogs(input: $input) {
    items {
      id
      username
      model
      tokens
      title
      messages
      createdAt
    }
    pagination {
      page
      pageSize
      total
    }
  }
}
    `
export const useChataiLogsQuery = <TData = ChataiLogsQuery, TError = unknown>(
  variables: ChataiLogsQueryVariables,
  options?: UseQueryOptions<ChataiLogsQuery, TError, TData>
) =>
  useQuery<ChataiLogsQuery, TError, TData>(
    ['chataiLogs', variables],
    amplifyFetcher<ChataiLogsQuery, ChataiLogsQueryVariables>(ChataiLogsDocument, variables),
    options
  )
export const ExchangeRateDocument = `
    query exchangeRate($input: ExchangeRateInput!) {
  exchangeRate(input: $input) {
    jpy {
      rate
      updatedAt
    }
  }
}
    `
export const useExchangeRateQuery = <TData = ExchangeRateQuery, TError = unknown>(
  variables: ExchangeRateQueryVariables,
  options?: UseQueryOptions<ExchangeRateQuery, TError, TData>
) =>
  useQuery<ExchangeRateQuery, TError, TData>(
    ['exchangeRate', variables],
    amplifyFetcher<ExchangeRateQuery, ExchangeRateQueryVariables>(ExchangeRateDocument, variables),
    options
  )
export const HeadlineArticleStructureDocument = `
    query headlineArticleStructure($input: HeadlineArticleStructureInput!) {
  headlineArticleStructure(input: $input) {
    keyword
    items {
      title
      description
      length
      url
      headlines {
        level
        text
      }
    }
  }
}
    `
export const useHeadlineArticleStructureQuery = <TData = HeadlineArticleStructureQuery, TError = unknown>(
  variables: HeadlineArticleStructureQueryVariables,
  options?: UseQueryOptions<HeadlineArticleStructureQuery, TError, TData>
) =>
  useQuery<HeadlineArticleStructureQuery, TError, TData>(
    ['headlineArticleStructure', variables],
    amplifyFetcher<HeadlineArticleStructureQuery, HeadlineArticleStructureQueryVariables>(
      HeadlineArticleStructureDocument,
      variables
    ),
    options
  )
export const HeadlineArticleStructureHistoriesDocument = `
    query headlineArticleStructureHistories($input: HeadlineArticleStructureHistoriesInput) {
  headlineArticleStructureHistories(input: $input) {
    histories {
      id
      keyword
      state
      createdAt
    }
  }
}
    `
export const useHeadlineArticleStructureHistoriesQuery = <
  TData = HeadlineArticleStructureHistoriesQuery,
  TError = unknown,
>(
  variables?: HeadlineArticleStructureHistoriesQueryVariables,
  options?: UseQueryOptions<HeadlineArticleStructureHistoriesQuery, TError, TData>
) =>
  useQuery<HeadlineArticleStructureHistoriesQuery, TError, TData>(
    variables === undefined ? ['headlineArticleStructureHistories'] : ['headlineArticleStructureHistories', variables],
    amplifyFetcher<HeadlineArticleStructureHistoriesQuery, HeadlineArticleStructureHistoriesQueryVariables>(
      HeadlineArticleStructureHistoriesDocument,
      variables
    ),
    options
  )
export const FetchHeadlineArticleStructureDocument = `
    mutation fetchHeadlineArticleStructure($input: FetchHeadlineArticleStructureInput!) {
  fetchHeadlineArticleStructure(input: $input) {
    executeId
  }
}
    `
export const useFetchHeadlineArticleStructureMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    FetchHeadlineArticleStructureMutation,
    TError,
    FetchHeadlineArticleStructureMutationVariables,
    TContext
  >
) =>
  useMutation<FetchHeadlineArticleStructureMutation, TError, FetchHeadlineArticleStructureMutationVariables, TContext>(
    ['fetchHeadlineArticleStructure'],
    (variables?: FetchHeadlineArticleStructureMutationVariables) =>
      amplifyFetcher<FetchHeadlineArticleStructureMutation, FetchHeadlineArticleStructureMutationVariables>(
        FetchHeadlineArticleStructureDocument,
        variables
      )(),
    options
  )
export const RelatedKeywordsDocument = `
    query relatedKeywords($input: RelatedKeywordsInput!) {
  relatedKeywords(input: $input) {
    ideas {
      keyword
      query
      searchVolumes {
        year
        month
        searches
      }
      avgMonthlySearches
      competition
      competitionIndex
      lowTopOfPageBid
      highTopOfPageBid
    }
  }
}
    `
export const useRelatedKeywordsQuery = <TData = RelatedKeywordsQuery, TError = unknown>(
  variables: RelatedKeywordsQueryVariables,
  options?: UseQueryOptions<RelatedKeywordsQuery, TError, TData>
) =>
  useQuery<RelatedKeywordsQuery, TError, TData>(
    ['relatedKeywords', variables],
    amplifyFetcher<RelatedKeywordsQuery, RelatedKeywordsQueryVariables>(RelatedKeywordsDocument, variables),
    options
  )
export const RelatedKeywordHistoriesDocument = `
    query relatedKeywordHistories($input: RelatedKeywordHistoriesInput) {
  relatedKeywordHistories(input: $input) {
    histories {
      id
      keyword
      state
      createdAt
    }
  }
}
    `
export const useRelatedKeywordHistoriesQuery = <TData = RelatedKeywordHistoriesQuery, TError = unknown>(
  variables?: RelatedKeywordHistoriesQueryVariables,
  options?: UseQueryOptions<RelatedKeywordHistoriesQuery, TError, TData>
) =>
  useQuery<RelatedKeywordHistoriesQuery, TError, TData>(
    variables === undefined ? ['relatedKeywordHistories'] : ['relatedKeywordHistories', variables],
    amplifyFetcher<RelatedKeywordHistoriesQuery, RelatedKeywordHistoriesQueryVariables>(
      RelatedKeywordHistoriesDocument,
      variables
    ),
    options
  )
export const FetchRelatedKeywordsDocument = `
    mutation fetchRelatedKeywords($input: FetchRelatedKeywordsInput!) {
  fetchRelatedKeywords(input: $input) {
    executeId
  }
}
    `
export const useFetchRelatedKeywordsMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<FetchRelatedKeywordsMutation, TError, FetchRelatedKeywordsMutationVariables, TContext>
) =>
  useMutation<FetchRelatedKeywordsMutation, TError, FetchRelatedKeywordsMutationVariables, TContext>(
    ['fetchRelatedKeywords'],
    (variables?: FetchRelatedKeywordsMutationVariables) =>
      amplifyFetcher<FetchRelatedKeywordsMutation, FetchRelatedKeywordsMutationVariables>(
        FetchRelatedKeywordsDocument,
        variables
      )(),
    options
  )
export const SuggestsDocument = `
    query suggests($input: SuggestsInput!) {
  suggests(input: $input) {
    keyword
    suggests
    additionalSuggests
    plusSuggests
    alphabetPlusSuggests
  }
}
    `
export const useSuggestsQuery = <TData = SuggestsQuery, TError = unknown>(
  variables: SuggestsQueryVariables,
  options?: UseQueryOptions<SuggestsQuery, TError, TData>
) =>
  useQuery<SuggestsQuery, TError, TData>(
    ['suggests', variables],
    amplifyFetcher<SuggestsQuery, SuggestsQueryVariables>(SuggestsDocument, variables),
    options
  )
export const SuggestHistoriesDocument = `
    query suggestHistories($input: SuggestHistoriesInput) {
  suggestHistories(input: $input) {
    histories {
      id
      keyword
      state
      createdAt
    }
  }
}
    `
export const useSuggestHistoriesQuery = <TData = SuggestHistoriesQuery, TError = unknown>(
  variables?: SuggestHistoriesQueryVariables,
  options?: UseQueryOptions<SuggestHistoriesQuery, TError, TData>
) =>
  useQuery<SuggestHistoriesQuery, TError, TData>(
    variables === undefined ? ['suggestHistories'] : ['suggestHistories', variables],
    amplifyFetcher<SuggestHistoriesQuery, SuggestHistoriesQueryVariables>(SuggestHistoriesDocument, variables),
    options
  )
export const FetchSuggestsDocument = `
    mutation fetchSuggests($input: FetchSuggestsInput!) {
  fetchSuggests(input: $input) {
    executeId
  }
}
    `
export const useFetchSuggestsMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<FetchSuggestsMutation, TError, FetchSuggestsMutationVariables, TContext>
) =>
  useMutation<FetchSuggestsMutation, TError, FetchSuggestsMutationVariables, TContext>(
    ['fetchSuggests'],
    (variables?: FetchSuggestsMutationVariables) =>
      amplifyFetcher<FetchSuggestsMutation, FetchSuggestsMutationVariables>(FetchSuggestsDocument, variables)(),
    options
  )
export const UsersDocument = `
    query users($page: Int, $limit: Int) {
  users(page: $page, limit: $limit) {
    items {
      id
      name
      email
      role
      state
      self
      permissions
    }
    total
    hasNextPage
    hasPreviousPage
  }
}
    `
export const useUsersQuery = <TData = UsersQuery, TError = unknown>(
  variables?: UsersQueryVariables,
  options?: UseQueryOptions<UsersQuery, TError, TData>
) =>
  useQuery<UsersQuery, TError, TData>(
    variables === undefined ? ['users'] : ['users', variables],
    amplifyFetcher<UsersQuery, UsersQueryVariables>(UsersDocument, variables),
    options
  )
export const ActivateInviteUserDocument = `
    mutation activateInviteUser($input: ActivateInviteUserInput!) {
  activateInviteUser(input: $input) {
    clientMutationId
    successful
  }
}
    `
export const useActivateInviteUserMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<ActivateInviteUserMutation, TError, ActivateInviteUserMutationVariables, TContext>
) =>
  useMutation<ActivateInviteUserMutation, TError, ActivateInviteUserMutationVariables, TContext>(
    ['activateInviteUser'],
    (variables?: ActivateInviteUserMutationVariables) =>
      amplifyFetcher<ActivateInviteUserMutation, ActivateInviteUserMutationVariables>(
        ActivateInviteUserDocument,
        variables
      )(),
    options
  )
export const CreateUserDocument = `
    mutation createUser($input: CreateUserInput!) {
  createUser(input: $input) {
    clientMutationId
    successful
  }
}
    `
export const useCreateUserMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CreateUserMutation, TError, CreateUserMutationVariables, TContext>
) =>
  useMutation<CreateUserMutation, TError, CreateUserMutationVariables, TContext>(
    ['createUser'],
    (variables?: CreateUserMutationVariables) =>
      amplifyFetcher<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, variables)(),
    options
  )
export const CreateInviteUserDocument = `
    mutation createInviteUser($input: CreateInviteUserInput!) {
  createInviteUser(input: $input) {
    successful
    error
  }
}
    `
export const useCreateInviteUserMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CreateInviteUserMutation, TError, CreateInviteUserMutationVariables, TContext>
) =>
  useMutation<CreateInviteUserMutation, TError, CreateInviteUserMutationVariables, TContext>(
    ['createInviteUser'],
    (variables?: CreateInviteUserMutationVariables) =>
      amplifyFetcher<CreateInviteUserMutation, CreateInviteUserMutationVariables>(
        CreateInviteUserDocument,
        variables
      )(),
    options
  )
export const DeleteUserDocument = `
    mutation deleteUser($input: DeleteUserInput!) {
  deleteUser(input: $input) {
    clientMutationId
  }
}
    `
export const useDeleteUserMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<DeleteUserMutation, TError, DeleteUserMutationVariables, TContext>
) =>
  useMutation<DeleteUserMutation, TError, DeleteUserMutationVariables, TContext>(
    ['deleteUser'],
    (variables?: DeleteUserMutationVariables) =>
      amplifyFetcher<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, variables)(),
    options
  )
export const UpdateUserDocument = `
    mutation updateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    clientMutationId
    error
    isEmailChange
  }
}
    `
export const useUpdateUserMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>
) =>
  useMutation<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>(
    ['updateUser'],
    (variables?: UpdateUserMutationVariables) =>
      amplifyFetcher<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, variables)(),
    options
  )
export const UpdateUserPermissionDocument = `
    mutation updateUserPermission($input: UpdateUserPermissionInput!) {
  updateUserPermission(input: $input) {
    clientMutationId
  }
}
    `
export const useUpdateUserPermissionMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<UpdateUserPermissionMutation, TError, UpdateUserPermissionMutationVariables, TContext>
) =>
  useMutation<UpdateUserPermissionMutation, TError, UpdateUserPermissionMutationVariables, TContext>(
    ['updateUserPermission'],
    (variables?: UpdateUserPermissionMutationVariables) =>
      amplifyFetcher<UpdateUserPermissionMutation, UpdateUserPermissionMutationVariables>(
        UpdateUserPermissionDocument,
        variables
      )(),
    options
  )
export const UpdateUserActiveDocument = `
    mutation updateUserActive($input: UpdateUserActiveInput!) {
  updateUserActive(input: $input) {
    successful
  }
}
    `
export const useUpdateUserActiveMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<UpdateUserActiveMutation, TError, UpdateUserActiveMutationVariables, TContext>
) =>
  useMutation<UpdateUserActiveMutation, TError, UpdateUserActiveMutationVariables, TContext>(
    ['updateUserActive'],
    (variables?: UpdateUserActiveMutationVariables) =>
      amplifyFetcher<UpdateUserActiveMutation, UpdateUserActiveMutationVariables>(
        UpdateUserActiveDocument,
        variables
      )(),
    options
  )
export const UpdateUserEmailDocument = `
    mutation updateUserEmail($input: UpdateUserEmailInput!) {
  updateUserEmail(input: $input) {
    clientMutationId
    successful
  }
}
    `
export const useUpdateUserEmailMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<UpdateUserEmailMutation, TError, UpdateUserEmailMutationVariables, TContext>
) =>
  useMutation<UpdateUserEmailMutation, TError, UpdateUserEmailMutationVariables, TContext>(
    ['updateUserEmail'],
    (variables?: UpdateUserEmailMutationVariables) =>
      amplifyFetcher<UpdateUserEmailMutation, UpdateUserEmailMutationVariables>(UpdateUserEmailDocument, variables)(),
    options
  )
export const SendInviteUserEmailDocument = `
    mutation sendInviteUserEmail($input: SendInviteUserEmailInput!) {
  sendInviteUserEmail(input: $input) {
    clientMutationId
  }
}
    `
export const useSendInviteUserEmailMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<SendInviteUserEmailMutation, TError, SendInviteUserEmailMutationVariables, TContext>
) =>
  useMutation<SendInviteUserEmailMutation, TError, SendInviteUserEmailMutationVariables, TContext>(
    ['sendInviteUserEmail'],
    (variables?: SendInviteUserEmailMutationVariables) =>
      amplifyFetcher<SendInviteUserEmailMutation, SendInviteUserEmailMutationVariables>(
        SendInviteUserEmailDocument,
        variables
      )(),
    options
  )

export type ResolverTypeWrapper<T> = Promise<T> | T

export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>
}
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | ResolverWithResolve<TResult, TParent, TContext, TArgs>

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (
  obj: T,
  context: TContext,
  info: GraphQLResolveInfo
) => boolean | Promise<boolean>

export type NextResolverFn<T> = () => Promise<T>

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>

/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = {
  Deletable: never
  Node: ChataiConversation | ProjectUser | User
}

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AWSDate: ResolverTypeWrapper<Scalars['AWSDate']['output']>
  AWSDateTime: ResolverTypeWrapper<Scalars['AWSDateTime']['output']>
  AWSEmail: ResolverTypeWrapper<Scalars['AWSEmail']['output']>
  AWSIPAddress: ResolverTypeWrapper<Scalars['AWSIPAddress']['output']>
  AWSJSON: ResolverTypeWrapper<Scalars['AWSJSON']['output']>
  AWSPhone: ResolverTypeWrapper<Scalars['AWSPhone']['output']>
  AWSTime: ResolverTypeWrapper<Scalars['AWSTime']['output']>
  AWSTimestamp: ResolverTypeWrapper<Scalars['AWSTimestamp']['output']>
  AWSURL: ResolverTypeWrapper<Scalars['AWSURL']['output']>
  ActivateInviteUserInput: ActivateInviteUserInput
  ActivateInviteUserPayload: ResolverTypeWrapper<ActivateInviteUserPayload>
  AiHeadlineArticleHeadline: ResolverTypeWrapper<AiHeadlineArticleHeadline>
  AiHeadlineArticleInfo: ResolverTypeWrapper<AiHeadlineArticleInfo>
  AiHeadlineArticleStructureConnection: ResolverTypeWrapper<AiHeadlineArticleStructureConnection>
  AiHeadlineArticleStructureHistoriesInput: AiHeadlineArticleStructureHistoriesInput
  AiHeadlineArticleStructureHistoriesResponse: ResolverTypeWrapper<AiHeadlineArticleStructureHistoriesResponse>
  AiHeadlineArticleStructureHistory: ResolverTypeWrapper<AiHeadlineArticleStructureHistory>
  AiHeadlineArticleStructureInput: AiHeadlineArticleStructureInput
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>
  BuildChataiRequestHeader: ResolverTypeWrapper<BuildChataiRequestHeader>
  BuildChataiRequestInput: BuildChataiRequestInput
  BuildChataiRequestMethod: BuildChataiRequestMethod
  BuildChataiRequestPayload: ResolverTypeWrapper<BuildChataiRequestPayload>
  ChataiConversation: ResolverTypeWrapper<ChataiConversation>
  ChataiConversationPayload: ResolverTypeWrapper<ChataiConversationPayload>
  ChataiConversationsConnection: ResolverTypeWrapper<ChataiConversationsConnection>
  ChataiConversationsInput: ChataiConversationsInput
  ChataiConversationsOrder: ChataiConversationsOrder
  ChataiConversationsOrderField: ChataiConversationsOrderField
  ChataiLog: ResolverTypeWrapper<ChataiLog>
  ChataiLogsConnection: ResolverTypeWrapper<ChataiLogsConnection>
  ChataiLogsInput: ChataiLogsInput
  ChataiLogsOrder: ChataiLogsOrder
  ChataiLogsOrderField: ChataiLogsOrderField
  ChataiMessage: ResolverTypeWrapper<ChataiMessage>
  ChataiRole: ChataiRole
  ChataiUsage: ResolverTypeWrapper<ChataiUsage>
  Company: ResolverTypeWrapper<Company>
  CreateChataiConversationData: ResolverTypeWrapper<CreateChataiConversationData>
  CreateChataiConversationInput: CreateChataiConversationInput
  CreateChataiConversationPayload: ResolverTypeWrapper<CreateChataiConversationPayload>
  CreateChataiConversationState: CreateChataiConversationState
  CreateInviteUserInput: CreateInviteUserInput
  CreateInviteUserPayload: ResolverTypeWrapper<CreateInviteUserPayload>
  CreateInviteUserRole: CreateInviteUserRole
  CreateUserInput: CreateUserInput
  CreateUserPayload: ResolverTypeWrapper<CreateUserPayload>
  DateRange: DateRange
  Deletable: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Deletable']>
  DeleteChataiConversationPayload: ResolverTypeWrapper<DeleteChataiConversationPayload>
  DeleteChataiConversationsPayload: ResolverTypeWrapper<DeleteChataiConversationsPayload>
  DeleteUserInput: DeleteUserInput
  ExchangeRateBase: ExchangeRateBase
  ExchangeRateInput: ExchangeRateInput
  ExchangeRatePayload: ResolverTypeWrapper<ExchangeRatePayload>
  ExchangeRateSymbol: ResolverTypeWrapper<ExchangeRateSymbol>
  FetchAiHeadlineArticleStructureInput: FetchAiHeadlineArticleStructureInput
  FetchAiHeadlineArticleStructureResponse: ResolverTypeWrapper<FetchAiHeadlineArticleStructureResponse>
  FetchHeadlineArticleStructureInput: FetchHeadlineArticleStructureInput
  FetchHeadlineArticleStructureResponse: ResolverTypeWrapper<FetchHeadlineArticleStructureResponse>
  FetchRelatedKeywordsInput: FetchRelatedKeywordsInput
  FetchRelatedKeywordsResponse: ResolverTypeWrapper<FetchRelatedKeywordsResponse>
  FetchSuggestsInput: FetchSuggestsInput
  FetchSuggestsResponse: ResolverTypeWrapper<FetchSuggestsResponse>
  Float: ResolverTypeWrapper<Scalars['Float']['output']>
  GenerateChataiTitlePayload: ResolverTypeWrapper<GenerateChataiTitlePayload>
  HeadlineArticleHeadline: ResolverTypeWrapper<HeadlineArticleHeadline>
  HeadlineArticleStructureConnection: ResolverTypeWrapper<HeadlineArticleStructureConnection>
  HeadlineArticleStructureHistoriesInput: HeadlineArticleStructureHistoriesInput
  HeadlineArticleStructureHistoriesResponse: ResolverTypeWrapper<HeadlineArticleStructureHistoriesResponse>
  HeadlineArticleStructureHistory: ResolverTypeWrapper<HeadlineArticleStructureHistory>
  HeadlineArticleStructureInput: HeadlineArticleStructureInput
  HeadlineArticleStructurePayload: ResolverTypeWrapper<HeadlineArticleStructurePayload>
  ID: ResolverTypeWrapper<Scalars['ID']['output']>
  Int: ResolverTypeWrapper<Scalars['Int']['output']>
  Mutation: ResolverTypeWrapper<{}>
  Node: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Node']>
  NumberRange: NumberRange
  OrderDirection: OrderDirection
  PageInfo: ResolverTypeWrapper<PageInfo>
  PaginationInput: PaginationInput
  PaginationPayload: ResolverTypeWrapper<PaginationPayload>
  Permission: Permission
  ProjectUser: ResolverTypeWrapper<ProjectUser>
  ProjectUserEditableRole: ProjectUserEditableRole
  ProjectUserRole: ProjectUserRole
  ProjectUserState: ProjectUserState
  Query: ResolverTypeWrapper<{}>
  QueryType: QueryType
  RelatedKeywordHistoriesInput: RelatedKeywordHistoriesInput
  RelatedKeywordHistoriesResponse: ResolverTypeWrapper<RelatedKeywordHistoriesResponse>
  RelatedKeywordHistory: ResolverTypeWrapper<RelatedKeywordHistory>
  RelatedKeywordsInput: RelatedKeywordsInput
  RelatedKeywordsResponse: ResolverTypeWrapper<RelatedKeywordsResponse>
  SendInviteUserEmailInput: SendInviteUserEmailInput
  SendInviteUserEmailPayload: ResolverTypeWrapper<SendInviteUserEmailPayload>
  String: ResolverTypeWrapper<Scalars['String']['output']>
  SuggestFetchState: SuggestFetchState
  SuggestHistoriesInput: SuggestHistoriesInput
  SuggestHistory: ResolverTypeWrapper<SuggestHistory>
  SuggestIdeas: ResolverTypeWrapper<SuggestIdeas>
  SuggestIdeasSearchVolumes: ResolverTypeWrapper<SuggestIdeasSearchVolumes>
  SuggestsHistoryResponse: ResolverTypeWrapper<SuggestsHistoryResponse>
  SuggestsInput: SuggestsInput
  SuggestsResponse: ResolverTypeWrapper<SuggestsResponse>
  UpdateUserActiveControl: UpdateUserActiveControl
  UpdateUserActiveInput: UpdateUserActiveInput
  UpdateUserActivePayload: ResolverTypeWrapper<UpdateUserActivePayload>
  UpdateUserEmailInput: UpdateUserEmailInput
  UpdateUserEmailPayload: ResolverTypeWrapper<UpdateUserEmailPayload>
  UpdateUserInput: UpdateUserInput
  UpdateUserPayload: ResolverTypeWrapper<UpdateUserPayload>
  UpdateUserPermissionInput: UpdateUserPermissionInput
  UpdateUserPermissionPayload: ResolverTypeWrapper<UpdateUserPermissionPayload>
  User: ResolverTypeWrapper<User>
  UsersConnection: ResolverTypeWrapper<UsersConnection>
  Viewer: ResolverTypeWrapper<Viewer>
}

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AWSDate: Scalars['AWSDate']['output']
  AWSDateTime: Scalars['AWSDateTime']['output']
  AWSEmail: Scalars['AWSEmail']['output']
  AWSIPAddress: Scalars['AWSIPAddress']['output']
  AWSJSON: Scalars['AWSJSON']['output']
  AWSPhone: Scalars['AWSPhone']['output']
  AWSTime: Scalars['AWSTime']['output']
  AWSTimestamp: Scalars['AWSTimestamp']['output']
  AWSURL: Scalars['AWSURL']['output']
  ActivateInviteUserInput: ActivateInviteUserInput
  ActivateInviteUserPayload: ActivateInviteUserPayload
  AiHeadlineArticleHeadline: AiHeadlineArticleHeadline
  AiHeadlineArticleInfo: AiHeadlineArticleInfo
  AiHeadlineArticleStructureConnection: AiHeadlineArticleStructureConnection
  AiHeadlineArticleStructureHistoriesInput: AiHeadlineArticleStructureHistoriesInput
  AiHeadlineArticleStructureHistoriesResponse: AiHeadlineArticleStructureHistoriesResponse
  AiHeadlineArticleStructureHistory: AiHeadlineArticleStructureHistory
  AiHeadlineArticleStructureInput: AiHeadlineArticleStructureInput
  Boolean: Scalars['Boolean']['output']
  BuildChataiRequestHeader: BuildChataiRequestHeader
  BuildChataiRequestInput: BuildChataiRequestInput
  BuildChataiRequestPayload: BuildChataiRequestPayload
  ChataiConversation: ChataiConversation
  ChataiConversationPayload: ChataiConversationPayload
  ChataiConversationsConnection: ChataiConversationsConnection
  ChataiConversationsInput: ChataiConversationsInput
  ChataiConversationsOrder: ChataiConversationsOrder
  ChataiLog: ChataiLog
  ChataiLogsConnection: ChataiLogsConnection
  ChataiLogsInput: ChataiLogsInput
  ChataiLogsOrder: ChataiLogsOrder
  ChataiMessage: ChataiMessage
  ChataiUsage: ChataiUsage
  Company: Company
  CreateChataiConversationData: CreateChataiConversationData
  CreateChataiConversationInput: CreateChataiConversationInput
  CreateChataiConversationPayload: CreateChataiConversationPayload
  CreateInviteUserInput: CreateInviteUserInput
  CreateInviteUserPayload: CreateInviteUserPayload
  CreateUserInput: CreateUserInput
  CreateUserPayload: CreateUserPayload
  DateRange: DateRange
  Deletable: ResolversInterfaceTypes<ResolversParentTypes>['Deletable']
  DeleteChataiConversationPayload: DeleteChataiConversationPayload
  DeleteChataiConversationsPayload: DeleteChataiConversationsPayload
  DeleteUserInput: DeleteUserInput
  ExchangeRateInput: ExchangeRateInput
  ExchangeRatePayload: ExchangeRatePayload
  ExchangeRateSymbol: ExchangeRateSymbol
  FetchAiHeadlineArticleStructureInput: FetchAiHeadlineArticleStructureInput
  FetchAiHeadlineArticleStructureResponse: FetchAiHeadlineArticleStructureResponse
  FetchHeadlineArticleStructureInput: FetchHeadlineArticleStructureInput
  FetchHeadlineArticleStructureResponse: FetchHeadlineArticleStructureResponse
  FetchRelatedKeywordsInput: FetchRelatedKeywordsInput
  FetchRelatedKeywordsResponse: FetchRelatedKeywordsResponse
  FetchSuggestsInput: FetchSuggestsInput
  FetchSuggestsResponse: FetchSuggestsResponse
  Float: Scalars['Float']['output']
  GenerateChataiTitlePayload: GenerateChataiTitlePayload
  HeadlineArticleHeadline: HeadlineArticleHeadline
  HeadlineArticleStructureConnection: HeadlineArticleStructureConnection
  HeadlineArticleStructureHistoriesInput: HeadlineArticleStructureHistoriesInput
  HeadlineArticleStructureHistoriesResponse: HeadlineArticleStructureHistoriesResponse
  HeadlineArticleStructureHistory: HeadlineArticleStructureHistory
  HeadlineArticleStructureInput: HeadlineArticleStructureInput
  HeadlineArticleStructurePayload: HeadlineArticleStructurePayload
  ID: Scalars['ID']['output']
  Int: Scalars['Int']['output']
  Mutation: {}
  Node: ResolversInterfaceTypes<ResolversParentTypes>['Node']
  NumberRange: NumberRange
  PageInfo: PageInfo
  PaginationInput: PaginationInput
  PaginationPayload: PaginationPayload
  ProjectUser: ProjectUser
  Query: {}
  RelatedKeywordHistoriesInput: RelatedKeywordHistoriesInput
  RelatedKeywordHistoriesResponse: RelatedKeywordHistoriesResponse
  RelatedKeywordHistory: RelatedKeywordHistory
  RelatedKeywordsInput: RelatedKeywordsInput
  RelatedKeywordsResponse: RelatedKeywordsResponse
  SendInviteUserEmailInput: SendInviteUserEmailInput
  SendInviteUserEmailPayload: SendInviteUserEmailPayload
  String: Scalars['String']['output']
  SuggestHistoriesInput: SuggestHistoriesInput
  SuggestHistory: SuggestHistory
  SuggestIdeas: SuggestIdeas
  SuggestIdeasSearchVolumes: SuggestIdeasSearchVolumes
  SuggestsHistoryResponse: SuggestsHistoryResponse
  SuggestsInput: SuggestsInput
  SuggestsResponse: SuggestsResponse
  UpdateUserActiveControl: UpdateUserActiveControl
  UpdateUserActiveInput: UpdateUserActiveInput
  UpdateUserActivePayload: UpdateUserActivePayload
  UpdateUserEmailInput: UpdateUserEmailInput
  UpdateUserEmailPayload: UpdateUserEmailPayload
  UpdateUserInput: UpdateUserInput
  UpdateUserPayload: UpdateUserPayload
  UpdateUserPermissionInput: UpdateUserPermissionInput
  UpdateUserPermissionPayload: UpdateUserPermissionPayload
  User: User
  UsersConnection: UsersConnection
  Viewer: Viewer
}

export type AwsApiKeyDirectiveArgs = {}

export type AwsApiKeyDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = AwsApiKeyDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>

export type AwsAuthDirectiveArgs = {
  cognito_groups: Array<Scalars['String']['input']>
}

export type AwsAuthDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = AwsAuthDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>

export type AwsCognitoUserPoolsDirectiveArgs = {
  cognito_groups?: Maybe<Array<Scalars['String']['input']>>
}

export type AwsCognitoUserPoolsDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = AwsCognitoUserPoolsDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>

export type AwsIamDirectiveArgs = {}

export type AwsIamDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = AwsIamDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>

export type AwsOidcDirectiveArgs = {}

export type AwsOidcDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = AwsOidcDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>

export type AwsSubscribeDirectiveArgs = {
  mutations: Array<Scalars['String']['input']>
}

export type AwsSubscribeDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = AwsSubscribeDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>

export interface AwsDateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSDate'], any> {
  name: 'AWSDate'
}

export interface AwsDateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSDateTime'], any> {
  name: 'AWSDateTime'
}

export interface AwsEmailScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSEmail'], any> {
  name: 'AWSEmail'
}

export interface AwsipAddressScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSIPAddress'], any> {
  name: 'AWSIPAddress'
}

export interface AwsjsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSJSON'], any> {
  name: 'AWSJSON'
}

export interface AwsPhoneScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSPhone'], any> {
  name: 'AWSPhone'
}

export interface AwsTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSTime'], any> {
  name: 'AWSTime'
}

export interface AwsTimestampScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSTimestamp'], any> {
  name: 'AWSTimestamp'
}

export interface AwsurlScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSURL'], any> {
  name: 'AWSURL'
}

export type ActivateInviteUserPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ActivateInviteUserPayload'] = ResolversParentTypes['ActivateInviteUserPayload'],
> = {
  clientMutationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  successful?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AiHeadlineArticleHeadlineResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['AiHeadlineArticleHeadline'] = ResolversParentTypes['AiHeadlineArticleHeadline'],
> = {
  level?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AiHeadlineArticleInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AiHeadlineArticleInfo'] = ResolversParentTypes['AiHeadlineArticleInfo'],
> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AiHeadlineArticleStructureConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['AiHeadlineArticleStructureConnection'] = ResolversParentTypes['AiHeadlineArticleStructureConnection'],
> = {
  headlines?: Resolver<Array<ResolversTypes['AiHeadlineArticleHeadline']>, ParentType, ContextType>
  info?: Resolver<Array<ResolversTypes['AiHeadlineArticleInfo']>, ParentType, ContextType>
  keyword?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  persona?: Resolver<Array<ResolversTypes['AiHeadlineArticleInfo']>, ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AiHeadlineArticleStructureHistoriesResponseResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['AiHeadlineArticleStructureHistoriesResponse'] = ResolversParentTypes['AiHeadlineArticleStructureHistoriesResponse'],
> = {
  histories?: Resolver<Array<ResolversTypes['AiHeadlineArticleStructureHistory']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AiHeadlineArticleStructureHistoryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['AiHeadlineArticleStructureHistory'] = ResolversParentTypes['AiHeadlineArticleStructureHistory'],
> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  keyword?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  state?: Resolver<ResolversTypes['SuggestFetchState'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BuildChataiRequestHeaderResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BuildChataiRequestHeader'] = ResolversParentTypes['BuildChataiRequestHeader'],
> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BuildChataiRequestPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BuildChataiRequestPayload'] = ResolversParentTypes['BuildChataiRequestPayload'],
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  headers?: Resolver<Array<ResolversTypes['BuildChataiRequestHeader']>, ParentType, ContextType>
  method?: Resolver<ResolversTypes['BuildChataiRequestMethod'], ParentType, ContextType>
  url?: Resolver<ResolversTypes['AWSURL'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ChataiConversationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ChataiConversation'] = ResolversParentTypes['ChataiConversation'],
> = {
  detail?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ChataiConversationPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ChataiConversationPayload'] = ResolversParentTypes['ChataiConversationPayload'],
> = {
  createdAt?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>
  current?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  messages?: Resolver<Array<ResolversTypes['ChataiMessage']>, ParentType, ContextType>
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ChataiConversationsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ChataiConversationsConnection'] = ResolversParentTypes['ChataiConversationsConnection'],
> = {
  items?: Resolver<Array<ResolversTypes['ChataiConversation']>, ParentType, ContextType>
  pagination?: Resolver<ResolversTypes['PaginationPayload'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ChataiLogResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ChataiLog'] = ResolversParentTypes['ChataiLog'],
> = {
  createdAt?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  messages?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  tokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ChataiLogsConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ChataiLogsConnection'] = ResolversParentTypes['ChataiLogsConnection'],
> = {
  items?: Resolver<Array<ResolversTypes['ChataiLog']>, ParentType, ContextType>
  pagination?: Resolver<ResolversTypes['PaginationPayload'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ChataiMessageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ChataiMessage'] = ResolversParentTypes['ChataiMessage'],
> = {
  children?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  parent?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  role?: Resolver<ResolversTypes['ChataiRole'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ChataiUsageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ChataiUsage'] = ResolversParentTypes['ChataiUsage'],
> = {
  calls?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  month?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  tokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  users?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CompanyResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Company'] = ResolversParentTypes['Company'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CreateChataiConversationDataResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CreateChataiConversationData'] = ResolversParentTypes['CreateChataiConversationData'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  messages?: Resolver<Array<ResolversTypes['ChataiMessage']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CreateChataiConversationPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CreateChataiConversationPayload'] = ResolversParentTypes['CreateChataiConversationPayload'],
> = {
  data?: Resolver<Maybe<ResolversTypes['CreateChataiConversationData']>, ParentType, ContextType>
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  state?: Resolver<ResolversTypes['CreateChataiConversationState'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CreateInviteUserPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateInviteUserPayload'] = ResolversParentTypes['CreateInviteUserPayload'],
> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  successful?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CreateUserPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateUserPayload'] = ResolversParentTypes['CreateUserPayload'],
> = {
  clientMutationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  successful?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DeletableResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Deletable'] = ResolversParentTypes['Deletable'],
> = {
  __resolveType: TypeResolveFn<null, ParentType, ContextType>
  viewerCanDelete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
}

export type DeleteChataiConversationPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['DeleteChataiConversationPayload'] = ResolversParentTypes['DeleteChataiConversationPayload'],
> = {
  clientMutationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DeleteChataiConversationsPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['DeleteChataiConversationsPayload'] = ResolversParentTypes['DeleteChataiConversationsPayload'],
> = {
  successful?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ExchangeRatePayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExchangeRatePayload'] = ResolversParentTypes['ExchangeRatePayload'],
> = {
  jpy?: Resolver<ResolversTypes['ExchangeRateSymbol'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ExchangeRateSymbolResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExchangeRateSymbol'] = ResolversParentTypes['ExchangeRateSymbol'],
> = {
  rate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  updatedAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FetchAiHeadlineArticleStructureResponseResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['FetchAiHeadlineArticleStructureResponse'] = ResolversParentTypes['FetchAiHeadlineArticleStructureResponse'],
> = {
  executeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FetchHeadlineArticleStructureResponseResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['FetchHeadlineArticleStructureResponse'] = ResolversParentTypes['FetchHeadlineArticleStructureResponse'],
> = {
  executeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FetchRelatedKeywordsResponseResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['FetchRelatedKeywordsResponse'] = ResolversParentTypes['FetchRelatedKeywordsResponse'],
> = {
  executeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type FetchSuggestsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FetchSuggestsResponse'] = ResolversParentTypes['FetchSuggestsResponse'],
> = {
  executeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type GenerateChataiTitlePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['GenerateChataiTitlePayload'] = ResolversParentTypes['GenerateChataiTitlePayload'],
> = {
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type HeadlineArticleHeadlineResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HeadlineArticleHeadline'] = ResolversParentTypes['HeadlineArticleHeadline'],
> = {
  level?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type HeadlineArticleStructureConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['HeadlineArticleStructureConnection'] = ResolversParentTypes['HeadlineArticleStructureConnection'],
> = {
  items?: Resolver<Array<ResolversTypes['HeadlineArticleStructurePayload']>, ParentType, ContextType>
  keyword?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type HeadlineArticleStructureHistoriesResponseResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['HeadlineArticleStructureHistoriesResponse'] = ResolversParentTypes['HeadlineArticleStructureHistoriesResponse'],
> = {
  histories?: Resolver<Array<ResolversTypes['HeadlineArticleStructureHistory']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type HeadlineArticleStructureHistoryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['HeadlineArticleStructureHistory'] = ResolversParentTypes['HeadlineArticleStructureHistory'],
> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  keyword?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  state?: Resolver<ResolversTypes['SuggestFetchState'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type HeadlineArticleStructurePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['HeadlineArticleStructurePayload'] = ResolversParentTypes['HeadlineArticleStructurePayload'],
> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  headlines?: Resolver<Array<ResolversTypes['HeadlineArticleHeadline']>, ParentType, ContextType>
  length?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MutationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation'],
> = {
  activateInviteUser?: Resolver<
    ResolversTypes['ActivateInviteUserPayload'],
    ParentType,
    ContextType,
    RequireFields<MutationActivateInviteUserArgs, 'input'>
  >
  buildChataiRequest?: Resolver<
    ResolversTypes['BuildChataiRequestPayload'],
    ParentType,
    ContextType,
    RequireFields<MutationBuildChataiRequestArgs, 'input'>
  >
  createChataiConversation?: Resolver<
    ResolversTypes['CreateChataiConversationPayload'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateChataiConversationArgs, 'input'>
  >
  createInviteUser?: Resolver<
    ResolversTypes['CreateInviteUserPayload'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateInviteUserArgs, 'input'>
  >
  createUser?: Resolver<
    ResolversTypes['CreateUserPayload'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateUserArgs, 'input'>
  >
  deleteChataiConversation?: Resolver<
    ResolversTypes['DeleteChataiConversationPayload'],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteChataiConversationArgs, 'id'>
  >
  deleteChataiConversations?: Resolver<ResolversTypes['DeleteChataiConversationsPayload'], ParentType, ContextType>
  deleteUser?: Resolver<
    ResolversTypes['UpdateUserPayload'],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteUserArgs, 'input'>
  >
  fetchAiHeadlineArticleStructure?: Resolver<
    ResolversTypes['FetchAiHeadlineArticleStructureResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationFetchAiHeadlineArticleStructureArgs, 'input'>
  >
  fetchHeadlineArticleStructure?: Resolver<
    ResolversTypes['FetchAiHeadlineArticleStructureResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationFetchHeadlineArticleStructureArgs, 'input'>
  >
  fetchRelatedKeywords?: Resolver<
    ResolversTypes['FetchRelatedKeywordsResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationFetchRelatedKeywordsArgs, 'input'>
  >
  fetchSuggests?: Resolver<
    ResolversTypes['FetchSuggestsResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationFetchSuggestsArgs, 'input'>
  >
  generateChataiTitle?: Resolver<
    Maybe<ResolversTypes['GenerateChataiTitlePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationGenerateChataiTitleArgs, 'id'>
  >
  sendInviteUserEmail?: Resolver<
    ResolversTypes['SendInviteUserEmailPayload'],
    ParentType,
    ContextType,
    RequireFields<MutationSendInviteUserEmailArgs, 'input'>
  >
  updateUser?: Resolver<
    ResolversTypes['UpdateUserPayload'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateUserArgs, 'input'>
  >
  updateUserActive?: Resolver<
    ResolversTypes['UpdateUserActivePayload'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateUserActiveArgs, 'input'>
  >
  updateUserEmail?: Resolver<
    ResolversTypes['UpdateUserEmailPayload'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateUserEmailArgs, 'input'>
  >
  updateUserPermission?: Resolver<
    ResolversTypes['UpdateUserPermissionPayload'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateUserPermissionArgs, 'input'>
  >
}

export type NodeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Node'] = ResolversParentTypes['Node'],
> = {
  __resolveType: TypeResolveFn<'ChataiConversation' | 'ProjectUser' | 'User', ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
}

export type PageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo'],
> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PaginationPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PaginationPayload'] = ResolversParentTypes['PaginationPayload'],
> = {
  page?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  pageSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ProjectUserResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ProjectUser'] = ResolversParentTypes['ProjectUser'],
> = {
  email?: Resolver<ResolversTypes['AWSEmail'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  permissions?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>
  role?: Resolver<ResolversTypes['ProjectUserRole'], ParentType, ContextType>
  self?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  state?: Resolver<ResolversTypes['ProjectUserState'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type QueryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query'],
> = {
  aiHeadlineArticleStructure?: Resolver<
    ResolversTypes['AiHeadlineArticleStructureConnection'],
    ParentType,
    ContextType,
    RequireFields<QueryAiHeadlineArticleStructureArgs, 'input'>
  >
  aiHeadlineArticleStructureHistories?: Resolver<
    ResolversTypes['AiHeadlineArticleStructureHistoriesResponse'],
    ParentType,
    ContextType,
    Partial<QueryAiHeadlineArticleStructureHistoriesArgs>
  >
  chataiConversation?: Resolver<
    Maybe<ResolversTypes['ChataiConversationPayload']>,
    ParentType,
    ContextType,
    RequireFields<QueryChataiConversationArgs, 'id'>
  >
  chataiConversations?: Resolver<
    Maybe<ResolversTypes['ChataiConversationsConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryChataiConversationsArgs, 'input'>
  >
  chataiLogs?: Resolver<
    Maybe<ResolversTypes['ChataiLogsConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryChataiLogsArgs, 'input'>
  >
  chataiUsage?: Resolver<Maybe<Array<ResolversTypes['ChataiUsage']>>, ParentType, ContextType>
  exchangeRate?: Resolver<
    Maybe<ResolversTypes['ExchangeRatePayload']>,
    ParentType,
    ContextType,
    RequireFields<QueryExchangeRateArgs, 'input'>
  >
  headlineArticleStructure?: Resolver<
    ResolversTypes['HeadlineArticleStructureConnection'],
    ParentType,
    ContextType,
    RequireFields<QueryHeadlineArticleStructureArgs, 'input'>
  >
  headlineArticleStructureHistories?: Resolver<
    ResolversTypes['HeadlineArticleStructureHistoriesResponse'],
    ParentType,
    ContextType,
    Partial<QueryHeadlineArticleStructureHistoriesArgs>
  >
  relatedKeywordHistories?: Resolver<
    ResolversTypes['RelatedKeywordHistoriesResponse'],
    ParentType,
    ContextType,
    Partial<QueryRelatedKeywordHistoriesArgs>
  >
  relatedKeywords?: Resolver<
    ResolversTypes['RelatedKeywordsResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryRelatedKeywordsArgs, 'input'>
  >
  suggestHistories?: Resolver<
    ResolversTypes['SuggestsHistoryResponse'],
    ParentType,
    ContextType,
    Partial<QuerySuggestHistoriesArgs>
  >
  suggests?: Resolver<
    ResolversTypes['SuggestsResponse'],
    ParentType,
    ContextType,
    RequireFields<QuerySuggestsArgs, 'input'>
  >
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QueryUserArgs, 'id'>>
  users?: Resolver<Maybe<ResolversTypes['UsersConnection']>, ParentType, ContextType, Partial<QueryUsersArgs>>
  viewer?: Resolver<ResolversTypes['Viewer'], ParentType, ContextType, Partial<QueryViewerArgs>>
}

export type RelatedKeywordHistoriesResponseResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['RelatedKeywordHistoriesResponse'] = ResolversParentTypes['RelatedKeywordHistoriesResponse'],
> = {
  histories?: Resolver<Array<ResolversTypes['RelatedKeywordHistory']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RelatedKeywordHistoryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RelatedKeywordHistory'] = ResolversParentTypes['RelatedKeywordHistory'],
> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  keyword?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  state?: Resolver<ResolversTypes['SuggestFetchState'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RelatedKeywordsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RelatedKeywordsResponse'] = ResolversParentTypes['RelatedKeywordsResponse'],
> = {
  ideas?: Resolver<Array<ResolversTypes['SuggestIdeas']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SendInviteUserEmailPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['SendInviteUserEmailPayload'] = ResolversParentTypes['SendInviteUserEmailPayload'],
> = {
  clientMutationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SuggestHistoryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SuggestHistory'] = ResolversParentTypes['SuggestHistory'],
> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  keyword?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  state?: Resolver<ResolversTypes['SuggestFetchState'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SuggestIdeasResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SuggestIdeas'] = ResolversParentTypes['SuggestIdeas'],
> = {
  avgMonthlySearches?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  competition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  competitionIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  highTopOfPageBid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  keyword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  lowTopOfPageBid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  query?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  searchVolumes?: Resolver<Maybe<Array<Maybe<ResolversTypes['SuggestIdeasSearchVolumes']>>>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SuggestIdeasSearchVolumesResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['SuggestIdeasSearchVolumes'] = ResolversParentTypes['SuggestIdeasSearchVolumes'],
> = {
  month?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  searches?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SuggestsHistoryResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SuggestsHistoryResponse'] = ResolversParentTypes['SuggestsHistoryResponse'],
> = {
  histories?: Resolver<Array<ResolversTypes['SuggestHistory']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SuggestsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SuggestsResponse'] = ResolversParentTypes['SuggestsResponse'],
> = {
  additionalSuggests?: Resolver<Array<Maybe<Array<ResolversTypes['String']>>>, ParentType, ContextType>
  alphabetPlusSuggests?: Resolver<Array<Maybe<Array<ResolversTypes['String']>>>, ParentType, ContextType>
  keyword?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  plusSuggests?: Resolver<Array<Maybe<Array<ResolversTypes['String']>>>, ParentType, ContextType>
  suggests?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UpdateUserActivePayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateUserActivePayload'] = ResolversParentTypes['UpdateUserActivePayload'],
> = {
  successful?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UpdateUserEmailPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateUserEmailPayload'] = ResolversParentTypes['UpdateUserEmailPayload'],
> = {
  clientMutationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  successful?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UpdateUserPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateUserPayload'] = ResolversParentTypes['UpdateUserPayload'],
> = {
  clientMutationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  isEmailChange?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UpdateUserPermissionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['UpdateUserPermissionPayload'] = ResolversParentTypes['UpdateUserPermissionPayload'],
> = {
  clientMutationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User'],
> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  login?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UsersConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UsersConnection'] = ResolversParentTypes['UsersConnection'],
> = {
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  items?: Resolver<Maybe<Array<ResolversTypes['ProjectUser']>>, ParentType, ContextType>
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ViewerResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Viewer'] = ResolversParentTypes['Viewer'],
> = {
  permissions?: Resolver<Array<ResolversTypes['Permission']>, ParentType, ContextType>
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type Resolvers<ContextType = any> = {
  AWSDate?: GraphQLScalarType
  AWSDateTime?: GraphQLScalarType
  AWSEmail?: GraphQLScalarType
  AWSIPAddress?: GraphQLScalarType
  AWSJSON?: GraphQLScalarType
  AWSPhone?: GraphQLScalarType
  AWSTime?: GraphQLScalarType
  AWSTimestamp?: GraphQLScalarType
  AWSURL?: GraphQLScalarType
  ActivateInviteUserPayload?: ActivateInviteUserPayloadResolvers<ContextType>
  AiHeadlineArticleHeadline?: AiHeadlineArticleHeadlineResolvers<ContextType>
  AiHeadlineArticleInfo?: AiHeadlineArticleInfoResolvers<ContextType>
  AiHeadlineArticleStructureConnection?: AiHeadlineArticleStructureConnectionResolvers<ContextType>
  AiHeadlineArticleStructureHistoriesResponse?: AiHeadlineArticleStructureHistoriesResponseResolvers<ContextType>
  AiHeadlineArticleStructureHistory?: AiHeadlineArticleStructureHistoryResolvers<ContextType>
  BuildChataiRequestHeader?: BuildChataiRequestHeaderResolvers<ContextType>
  BuildChataiRequestPayload?: BuildChataiRequestPayloadResolvers<ContextType>
  ChataiConversation?: ChataiConversationResolvers<ContextType>
  ChataiConversationPayload?: ChataiConversationPayloadResolvers<ContextType>
  ChataiConversationsConnection?: ChataiConversationsConnectionResolvers<ContextType>
  ChataiLog?: ChataiLogResolvers<ContextType>
  ChataiLogsConnection?: ChataiLogsConnectionResolvers<ContextType>
  ChataiMessage?: ChataiMessageResolvers<ContextType>
  ChataiUsage?: ChataiUsageResolvers<ContextType>
  Company?: CompanyResolvers<ContextType>
  CreateChataiConversationData?: CreateChataiConversationDataResolvers<ContextType>
  CreateChataiConversationPayload?: CreateChataiConversationPayloadResolvers<ContextType>
  CreateInviteUserPayload?: CreateInviteUserPayloadResolvers<ContextType>
  CreateUserPayload?: CreateUserPayloadResolvers<ContextType>
  Deletable?: DeletableResolvers<ContextType>
  DeleteChataiConversationPayload?: DeleteChataiConversationPayloadResolvers<ContextType>
  DeleteChataiConversationsPayload?: DeleteChataiConversationsPayloadResolvers<ContextType>
  ExchangeRatePayload?: ExchangeRatePayloadResolvers<ContextType>
  ExchangeRateSymbol?: ExchangeRateSymbolResolvers<ContextType>
  FetchAiHeadlineArticleStructureResponse?: FetchAiHeadlineArticleStructureResponseResolvers<ContextType>
  FetchHeadlineArticleStructureResponse?: FetchHeadlineArticleStructureResponseResolvers<ContextType>
  FetchRelatedKeywordsResponse?: FetchRelatedKeywordsResponseResolvers<ContextType>
  FetchSuggestsResponse?: FetchSuggestsResponseResolvers<ContextType>
  GenerateChataiTitlePayload?: GenerateChataiTitlePayloadResolvers<ContextType>
  HeadlineArticleHeadline?: HeadlineArticleHeadlineResolvers<ContextType>
  HeadlineArticleStructureConnection?: HeadlineArticleStructureConnectionResolvers<ContextType>
  HeadlineArticleStructureHistoriesResponse?: HeadlineArticleStructureHistoriesResponseResolvers<ContextType>
  HeadlineArticleStructureHistory?: HeadlineArticleStructureHistoryResolvers<ContextType>
  HeadlineArticleStructurePayload?: HeadlineArticleStructurePayloadResolvers<ContextType>
  Mutation?: MutationResolvers<ContextType>
  Node?: NodeResolvers<ContextType>
  PageInfo?: PageInfoResolvers<ContextType>
  PaginationPayload?: PaginationPayloadResolvers<ContextType>
  ProjectUser?: ProjectUserResolvers<ContextType>
  Query?: QueryResolvers<ContextType>
  RelatedKeywordHistoriesResponse?: RelatedKeywordHistoriesResponseResolvers<ContextType>
  RelatedKeywordHistory?: RelatedKeywordHistoryResolvers<ContextType>
  RelatedKeywordsResponse?: RelatedKeywordsResponseResolvers<ContextType>
  SendInviteUserEmailPayload?: SendInviteUserEmailPayloadResolvers<ContextType>
  SuggestHistory?: SuggestHistoryResolvers<ContextType>
  SuggestIdeas?: SuggestIdeasResolvers<ContextType>
  SuggestIdeasSearchVolumes?: SuggestIdeasSearchVolumesResolvers<ContextType>
  SuggestsHistoryResponse?: SuggestsHistoryResponseResolvers<ContextType>
  SuggestsResponse?: SuggestsResponseResolvers<ContextType>
  UpdateUserActivePayload?: UpdateUserActivePayloadResolvers<ContextType>
  UpdateUserEmailPayload?: UpdateUserEmailPayloadResolvers<ContextType>
  UpdateUserPayload?: UpdateUserPayloadResolvers<ContextType>
  UpdateUserPermissionPayload?: UpdateUserPermissionPayloadResolvers<ContextType>
  User?: UserResolvers<ContextType>
  UsersConnection?: UsersConnectionResolvers<ContextType>
  Viewer?: ViewerResolvers<ContextType>
}

export type DirectiveResolvers<ContextType = any> = {
  aws_api_key?: AwsApiKeyDirectiveResolver<any, any, ContextType>
  aws_auth?: AwsAuthDirectiveResolver<any, any, ContextType>
  aws_cognito_user_pools?: AwsCognitoUserPoolsDirectiveResolver<any, any, ContextType>
  aws_iam?: AwsIamDirectiveResolver<any, any, ContextType>
  aws_oidc?: AwsOidcDirectiveResolver<any, any, ContextType>
  aws_subscribe?: AwsSubscribeDirectiveResolver<any, any, ContextType>
}
